/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _promisePolyfill = __webpack_require__(2);
	
	var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
	
	__webpack_require__(5);
	
	var _serviceRegister = __webpack_require__(6);
	
	var _serviceRegister2 = _interopRequireDefault(_serviceRegister);
	
	var _popupSubscribe = __webpack_require__(10);
	
	var _popupSubscribe2 = _interopRequireDefault(_popupSubscribe);
	
	var _loginWatcher = __webpack_require__(36);
	
	var _loginWatcher2 = _interopRequireDefault(_loginWatcher);
	
	var _request = __webpack_require__(38);
	
	var _cookie = __webpack_require__(39);
	
	var _windowGa = __webpack_require__(40);
	
	var _windowGa2 = _interopRequireDefault(_windowGa);
	
	var _subscribeCategory = __webpack_require__(41);
	
	var _subscribeCategory2 = _interopRequireDefault(_subscribeCategory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isPopupShowOnce = false;
	var trackCategory = 'notification-push-article';
	
	if (!window.Promise) {
		window.Promise = _promisePolyfill2.default;
	}
	
	var NotificationFlowRegister = function () {
		function NotificationFlowRegister(subscribeManager) {
			var _this = this;
	
			_classCallCheck(this, NotificationFlowRegister);
	
			this.subscribeManager = subscribeManager;
			this.categoryMainName = '';
			this.isTimeForShow = false;
			this.isServiceInit = false;
			this.isServiceRegisted = false;
			this.isSubscribedCategory = false;
			this.categoryMain = 0;
			this.categorySub = 0;
			this.contentId = 0;
			this.onestopInstance = null;
			this.userInfo = {};
			this.stateChangeCallback = [];
			this.popup = new _popupSubscribe2.default();
			this.popup.hide();
			//this.onClickSubscribePopup = () => {};
			this.popup.onSubscribeClicked(function () {
				_this.onClickSubscribePopup.bind(_this)();
			});
	
			this.popup.onCloseClicked(function () {
				(0, _cookie.create)(_this.getPreventPopupCookieName(), 1, 60 * 60 * 24);
			});
			//this.subscribeManager.init()
		}
	
		_createClass(NotificationFlowRegister, [{
			key: 'init',
			value: function init() {
				return this.initService();
			}
		}, {
			key: 'getPreventPopupCookieName',
			value: function getPreventPopupCookieName() {
				return 'notification-popup-article-' + this.categoryMain;
			}
		}, {
			key: 'onClickSubscribePopup',
			value: function onClickSubscribePopup() {
				var _this2 = this;
	
				(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'clicked');
				//track(trackCategory, 'subscribe-click-prop-is-login', this.isLogin ? 'T' : 'F');
				//track(trackCategory, 'subscribe-click-prop-is-subcate', this.isSubscribedCategory ? 'T' : 'F');
				return new _promisePolyfill2.default(function (resolve, reject) {
					_this2.isUserLogin().then(function (isLogin) {
						if (isLogin) {
							(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'already-login');
							_this2.initService().then(function (isRegistered) {
								//console.log(isRegistered);
								(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'already-login-init');
								return _this2.registerToken();
							}).then(function () {
								(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'already-login-register');
								return _subscribeCategory2.default.subscribe(_this2.categoryMain);
							}).then(function (response) {
								(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'already-login-subscribe');
								_this2.popup.hide();
								alert('เรียบร้อย! คุณได้ติดตามบทความหมวดนี้แล้ว เราจะเตือนคุณเมื่อมีบทความใหม่ๆมานะ');
								return resolve(response);
								//this.popup.hide();
							}).catch(function (ex) {
								(0, _windowGa2.default)(trackCategory, 'subscribe-flow-fail-exception-l', ex);
								return reject(ex);
							});
						} else {
							(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'not-login');
							_this2.onestopInstance.start('login', function (status, info) {
								if (!status) {
									if (typeof info !== 'undefined' && typeof info.cause !== 'undefined') {
										return (0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'not-login-abort');
									}
								}
								(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'not-login-logged');
								_this2.initService().then(function (isRegistered) {
									(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'not-login-init');
									return _this2.registerToken();
								}).then(function () {
									(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'not-login-register');
									return _subscribeCategory2.default.subscribe(_this2.categoryMain);
								}).then(function (response) {
									(0, _windowGa2.default)(trackCategory, 'subscribe-flow', 'not-login-subscribed');
									_this2.popup.hide();
									alert('เรียบร้อย! คุณได้ติดตามบทความหมวดนี้แล้ว เราจะเตือนคุณเมื่อมีบทความใหม่ๆมานะ');
									return resolve(response);
								}).catch(function (ex) {
									(0, _windowGa2.default)(trackCategory, 'subscribe-flow-fail-exception-n', ex);
									return reject(ex);
								});
							}.bind(_this2));
						}
					});
				});
			}
	
			/**
	   *
	   * @returns Promise
	   */
	
		}, {
			key: 'requestLogin',
			value: function requestLogin(title) {
				var _this3 = this;
	
				return new _promisePolyfill2.default(function (resolve, reject) {
					_this3.onestopInstance.start(title, function (info) {
						_this3.setLoginState = true;
						_this3.stateChange();
						resolve(true, info);
					}, function () {
						resolve(false);
					});
					/*this.onestopInstance.onModalClose(() => {
	     reject();
	     })*/
				});
			}
	
			/**
	   *
	   * @returns Promise
	   */
	
		}, {
			key: 'isUserLogin',
			value: function isUserLogin() {
				var _this4 = this;
	
				return new _promisePolyfill2.default(function (resolve, reject) {
					_this4.onestopInstance.checkLoginState(function (status, info) {
						//console.log('check login status', status, info);
						return resolve(status, info);
					});
				});
			}
	
			/**
	   *
	   * @returns Promise
	   */
	
		}, {
			key: 'initService',
			value: function initService() {
				var _this5 = this;
	
				//console.log('init service')
				return new _promisePolyfill2.default(function (resolve, reject) {
					if (_this5.isServiceInit) return resolve(_this5.isServiceRegisted);
	
					//console.log('this.subscribeManager.init() called')
	
					_this5.subscribeManager.init().then(function (isServiceRegistered) {
						//console.log('inited')
						_this5.isServiceInit = true;
						_this5.isServiceRegisted = isServiceRegistered;
						_this5.stateChange();
						return resolve(isServiceRegistered);
					}).catch(function (error) {
						//console.log(error)
						_this5.isServiceInit = false;
						return reject(error);
					});
				});
			}
		}, {
			key: 'registerToken',
			value: function registerToken() {
				var _this6 = this;
	
				return new _promisePolyfill2.default(function (resolve, reject) {
					/*if (this.isServiceRegisted) {
	    	this.subscribeManager.updateToken();
	    	return resolve({
	    		'status': true,
	    		'message': 'user already registered.'
	    	});
	    }*/
					_this6.subscribeManager.subscribe().then(function (jsonResponse) {
						_this6.isServiceRegisted = true;
						_this6.stateChange();
						resolve(jsonResponse);
					}).catch(function (error) {
						return reject(error);
					});
				});
			}
		}, {
			key: 'unRegisterToken',
			value: function unRegisterToken() {
				var _this7 = this;
	
				return new _promisePolyfill2.default(function (resolve, reject) {
					_this7.subscribeManager.unsubscribe().then(function (jsonResponse) {
						_this7.isServiceRegisted = false;
						_this7.stateChange();
						resolve(jsonResponse);
					}).catch(function (error) {
						return reject(error);
					});
				});
			}
		}, {
			key: 'isTokenRegistered',
			value: function isTokenRegistered() {
				return this.isServiceInit && this.isServiceRegisted;
			}
		}, {
			key: 'isPopupShouldShow',
			value: function isPopupShouldShow() {
				//alert('this.isTimeForShow' + (this.isTimeForShow ? ' T' : ' F'))
				/*console.log('ispopupshouldshow',
	   	'this.isTokenRegistered()', this.isTokenRegistered(),
	   'this.isLogin', this.isLogin,
	   'this.isSubscribedCategory', this.isSubscribedCategory,
	   'this.isPreventShowPopupByCookie != 1', this.isPreventShowPopupByCookie != 1,
	   'this.isTimeForShow', this.isTimeForShow,
	   'overall', !(
	   	this.isTokenRegistered()
	   	&& this.isLogin
	   	&& this.isSubscribedCategory)
	   	&& this.isPreventShowPopupByCookie != 1
	   	&& this.isTimeForShow)*/
				return !(this.isTokenRegistered() && this.isLogin && this.isSubscribedCategory) && this.isPreventShowPopupByCookie != 1 && this.isTimeForShow;
			}
		}, {
			key: 'renderPopup',
			value: function renderPopup() {
				//console.log('render popup')
				if (this.isPopupShouldShow()) {
					if (!isPopupShowOnce) {
						isPopupShowOnce = true;
						(0, _windowGa2.default)(trackCategory, 'popup-visible');
						(0, _windowGa2.default)(trackCategory, 'subscribe-click-prop-is-login', this.isLogin ? 'T' : 'F');
						(0, _windowGa2.default)(trackCategory, 'subscribe-click-prop-is-subcate', this.isSubscribedCategory ? 'T' : 'F');
					}
					this.popup.show();
				} else {
					this.popup.hide();
				}
			}
		}, {
			key: 'setLoginState',
			value: function setLoginState(isLogin, info) {
				this.isLogin = isLogin;
				this.userInfo = info;
				this.stateChange();
			}
		}, {
			key: 'setIsSubscribeCategory',
			value: function setIsSubscribeCategory(isSubscribed) {
				this.isSubscribedCategory = isSubscribed;
				this.stateChange();
			}
		}, {
			key: 'setCategoryMain',
			value: function setCategoryMain(categoryMain) {
				this.categoryMain = categoryMain;
				this.isPreventShowPopupByCookie = (0, _cookie.read)(this.getPreventPopupCookieName());
				this.stateChange();
			}
		}, {
			key: 'setCategoryMainName',
			value: function setCategoryMainName(name) {
				this.categoryMainName = name;
				this.popup.setCategoryName(this.categoryMainName);
			}
		}, {
			key: 'setCategorySub',
			value: function setCategorySub(categorySub) {
				this.categorySub = categorySub;
				this.stateChange();
			}
		}, {
			key: 'setContentId',
			value: function setContentId(contentId) {
				this.contentId = contentId;
				this.stateChange();
			}
		}, {
			key: 'setOnestopInstance',
			value: function setOnestopInstance(onestop) {
				this.onestopInstance = onestop;
			}
		}, {
			key: 'setIsTimeForShow',
			value: function setIsTimeForShow(shouldShow) {
				this.isTimeForShow = shouldShow;
				this.stateChange();
			}
		}, {
			key: 'onStateChange',
			value: function onStateChange(callback) {
				this.stateChangeCallback.push(callback);
			}
		}, {
			key: 'stateChange',
			value: function stateChange() {
				var _this8 = this;
	
				//console.log('state change', this.stateChangeCallback);
				//alert('state change '/* + typeof this.stateChangeCallback*/)
				this.stateChangeCallback.forEach(function (callback) {
					callback(_this8);
				});
			}
		}]);
	
		return NotificationFlowRegister;
	}();
	
	function startPushNotificationFlow(_ref) {
		var _ref$isSubscribedCate = _ref.isSubscribedCategory;
		var isSubscribedCategory = _ref$isSubscribedCate === undefined ? false : _ref$isSubscribedCate;
		var _ref$categoryMain = _ref.categoryMain;
		var categoryMain = _ref$categoryMain === undefined ? 0 : _ref$categoryMain;
		var _ref$categorySub = _ref.categorySub;
		var categorySub = _ref$categorySub === undefined ? 0 : _ref$categorySub;
		var _ref$contentId = _ref.contentId;
		var contentId = _ref$contentId === undefined ? 0 : _ref$contentId;
		var _ref$oneStop = _ref.oneStop;
		var oneStop = _ref$oneStop === undefined ? null : _ref$oneStop;
		var _ref$categoryMainName = _ref.categoryMainName;
		var categoryMainName = _ref$categoryMainName === undefined ? 'บทความ' : _ref$categoryMainName;
	
	
		//console.log('aaaaa');
	
		//alert('navigator.serviceWorker ' +  (typeof navigator.serviceWorker === 'undefined' ? 'T' : 'F'));
	
		//alert('navigator.serviceWorker '); return;
	
		var subscribeCategory = new _subscribeCategory2.default();
	
		var notificationRegister = new NotificationFlowRegister(_serviceRegister2.default);
		notificationRegister.setOnestopInstance(oneStop);
		notificationRegister.setCategoryMain(categoryMain);
		notificationRegister.setCategorySub(categorySub);
		notificationRegister.setContentId(contentId);
		notificationRegister.setCategoryMainName(categoryMainName);
		notificationRegister.setIsSubscribeCategory(isSubscribedCategory);
	
		//console.log('setTimeout')
		setTimeout(function () {
			//console.log('show time!')
			//alert('show time!')
			notificationRegister.setIsTimeForShow(true);
		}, 6000);
	
		var loginState = new _loginWatcher2.default();
		loginState.onLogin(function (info) {
			notificationRegister.setLoginState(true, info);
			_subscribeCategory2.default.isUserSubscribeCategory(categoryMain, categorySub).then(function (isSubscribe) {
				//console.log('aaa', isSubscribe);
				notificationRegister.setIsSubscribeCategory(isSubscribe);
			});
		});
		loginState.onLogout(function () {
			notificationRegister.setLoginState(false, {});
			notificationRegister.setIsSubscribeCategory(false);
		});
	
		notificationRegister.init().then(function () {
			notificationRegister.renderPopup();
	
			//console.log('init notificationRegister')
	
			notificationRegister.onStateChange(function (manager) {
				//console.log('on state change');
				manager.renderPopup();
			});
		}).catch(function (error) {
			console.log(error);
		});
	
		window.subscribe = function (callback) {
			notificationRegister.onClickSubscribePopup().then(function (response) {
				return callback(true, response);
			}).catch(function (error) {
				return callback(false, error);
			});
		};
	}
	
	window.startPushNotificationFlow = startPushNotificationFlow;
	window.unsub = _serviceRegister.unSubscribe;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    var args = Array.prototype.slice.call(arr);
	
	    return new Promise(function (resolve, reject) {
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).setImmediate))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(4).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).setImmediate, __webpack_require__(3).clearImmediate))

/***/ },
/* 4 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 5 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {//! Copyright 2012 Eric Wendelin - MIT License
	
	/**
	 * es6-map-shim.js is a DESTRUCTIVE shim that follows the latest Map specification as closely as possible.
	 * It is destructive in the sense that it overrides native implementations.
	 *
	 * This library assumes ES5 functionality: Object.create, Object.defineProperty, Array.indexOf, Function.bind
	 */
	(function(module) {
	    function Map(iterable) {
	        var _items = [];
	        var _keys = [];
	        var _values = [];
	
	        // Object.is polyfill, courtesy of @WebReflection
	        var is = Object.is || function(a, b) {
	            return a === b ?
	                a !== 0 || 1 / a == 1 / b :
	                a != a && b != b;
	        };
	
	        // More reliable indexOf, courtesy of @WebReflection
	        var betterIndexOf = function(value) {
	            if(value != value || value === 0) {
	                for(var i = this.length; i-- && !is(this[i], value););
	            } else {
	                i = [].indexOf.call(this, value);
	            }
	            return i;
	        };
	
	        var MapIterator = function MapIterator(map, kind) {
	            var _index = 0;
	
	            return Object.create({}, {
	                next: {
	                    value: function() {
	                        // check if index is within bounds
	                        if (_index < map.items().length) {
	                            switch(kind) {
	                                case 'keys': return map.keys()[_index++];
	                                case 'values': return map.values()[_index++];
	                                case 'keys+values': return [].slice.call(map.items()[_index++]);
	                                default: throw new TypeError('Invalid iterator type');
	                            }
	                        }
	                        // TODO: make sure I'm interpreting the spec correctly here
	                        throw new Error('Stop Iteration');
	                    }
	                },
	                iterator: {
	                    value: function() {
	                        return this;
	                    }
	                },
	                toString: {
	                    value: function() {
	                        return '[object Map Iterator]';
	                    }
	                }
	            });
	        };
	
	        var _set = function(key, value) {
	            // check if key exists and overwrite
	            var index = betterIndexOf.call(_keys, key);
	            if (index > -1) {
	                _items[index] = value;
	                _values[index] = value;
	            } else {
	                _items.push([key, value]);
	                _keys.push(key);
	                _values.push(value);
	            }
	        };
	
	        var setItem = function(item) {
	            if (item.length !== 2) {
	                throw new TypeError('Invalid iterable passed to Map constructor');
	            }
	
	            _set(item[0], item[1]);
	        };
	
	        // FIXME: accommodate any class that defines an @@iterator method that returns
	        //      an iterator object that produces two element array-like objects
	        if (Array.isArray(iterable)) {
	            iterable.forEach(setItem);
	        } else if (iterable !== undefined) {
	            throw new TypeError('Invalid Map');
	        }
	
	        return Object.create(MapPrototype, {
	            items:{
	                value:function() {
	                    return [].slice.call(_items);
	                }
	            },
	            keys:{
	                value:function() {
	                    return [].slice.call(_keys);
	                }
	            },
	            values:{
	                value:function() {
	                    return [].slice.call(_values);
	                }
	            },
	            has:{
	                value:function(key) {
	                    // TODO: check how spec reads about null values
	                    var index = betterIndexOf.call(_keys, key);
	                    return index > -1;
	                }
	            },
	            get:{
	                value:function(key) {
	                    var index = betterIndexOf.call(_keys, key);
	                    return index > -1 ? _values[index] : undefined;
	                }
	            },
	            set:{
	                value: _set
	            },
	            size:{
	                get:function() {
	                    return _items.length;
	                }
	            },
	            clear:{
	                value:function() {
	                    _keys.length = _values.length = _items.length = 0;
	                }
	            },
	            'delete':{
	                value:function(key) {
	                    var index = betterIndexOf.call(_keys, key);
	                    if (index > -1) {
	                        _keys.splice(index, 1);
	                        _values.splice(index, 1);
	                        _items.splice(index, 1);
	                        return true;
	                    }
	                    return false;
	                }
	            },
	            forEach:{
	                value:function(callbackfn /*, thisArg*/) {
	                    if (typeof callbackfn != 'function') {
	                        throw new TypeError('Invalid callback function given to forEach');
	                    }
	
	                    function tryNext() {
	                        try {
	                            return iter.next();
	                        } catch(e) {
	                            return undefined;
	                        }
	                    }
	
	                    var iter = this.iterator();
	                    var current = tryNext();
	                    var next = tryNext();
	                    while(current !== undefined) {
	                        callbackfn.apply(arguments[1], [current[1], current[0], this]);
	                        current = next;
	                        next = tryNext();
	                    }
	                }
	            },
	            iterator:{
	                value: function() {
	                    return new MapIterator(this, 'keys+values');
	                }
	            },
	            toString:{
	                value: function() {
	                    return '[Object Map]';
	                }
	            }
	        });
	    }
	
	    var notInNode = module == 'undefined';
	    var window = notInNode ? this : global;
	    var module = notInNode ? {} : exports;
	    var MapPrototype = Map.prototype;
	
	    Map.prototype = MapPrototype = Map();
	
	    window.Map = module.Map = window.Map || Map;
	}.call(this, typeof exports));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.unSubscribe = unSubscribe;
	exports.subscribe = subscribe;
	var subscribeManager = function (window) {
	
		/*navigator.serviceWorker.addEventListener('message', function (event) {
	 	if (event.source != navigator.serviceWorker.controller) {
	 		return;
	 	}
	 });*/
	
		return {
	
			registration: null,
			subscription: null,
			serviceWorkerPath: '/service-worker.js.php',
			registerTokenUrl: '/notification/register',
			unRegisterTokenUrl: '/notification/unregister',
	
			init: function init() {
				var _this = this;
	
				//alert('navigator.serviceWorker ' +  (typeof navigator.serviceWorker === 'undefined' ? 'T' : 'F'));
				if (typeof navigator.serviceWorker === 'undefined') return false;
	
				//console.log('subscribeManager init');
	
				return new Promise(function (resolve, reject) {
	
					//console.log('start Promise')
	
					/**
	     * Catch ready state
	     */
					navigator.serviceWorker.ready.then(function () {
						//console.log('ready')
						return resolve;
					}).catch(function (err) {
						//console.log(err)
						navigator.serviceWorker.register(_this.serviceWorkerPath).then(function () {
							//console.log('service ready')
							return resolve(navigator.serviceWorker.ready);
						}).catch(reject);
					});
	
					/**
	     * Register sw
	     */
					navigator.serviceWorker.register(_this.serviceWorkerPath).then(function () {
						//console.log('service register ready')
						return resolve(navigator.serviceWorker.ready);
					}).catch(reject);
				}).then(function (serviceWorkerRegistration) {
					//console.log('subscribeManager registered', serviceWorkerRegistration, this);
					_this.registration = serviceWorkerRegistration;
					//console.log('subscribeManager registered registration', this.registration);
					return serviceWorkerRegistration.pushManager.getSubscription().then(function (pushSubscription) {
						_this.subscription = pushSubscription;
						return _this.isSubscribe();
					});
				}).catch(function (error) {
					console.log(error);
					return error;
				});
			},
	
			isSubscribe: function isSubscribe() {
				return this.subscription !== null;
			},
	
			subscribe: function subscribe() {
				var _this2 = this;
	
				//console.log('call subscribe', this.isSubscribe(), this.subscription)
	
				if (this.isSubscribe()) {
					return new Promise(function (resolve, reject) {
						//console.log(this.subscription.toJSON());
						fetch(_this2.registerTokenUrl, {
							method: 'POST',
							credentials: 'include',
							body: "data_token=" + JSON.stringify(_this2.subscription.toJSON()),
							headers: { "Content-type": "application/x-www-form-urlencoded; charset=UTF-8" }
						}).then(function (response) {
							return response.json();
						}).then(function (jsonResponse) {
							//this.subscription = pushSubscription;
							//console.log('subscribe to dek-d complete.', jsonResponse);
							this.showWelcomeMessage();
							this.createSubscribeCookie();
							resolve(jsonResponse);
						}.bind(_this2)).catch(function (error) {
							reject(error);
						});
					});
				}
	
				return new Promise(function (resolve, reject) {
	
					//console.log('service worker subscribe::', this, this.registration)
					//console.log('zzzzzz', this.registration)
					_this2.registration.pushManager.subscribe({ userVisibleOnly: true }).then(function (pushSubscription) {
						//console.log('aaaa', pushSubscription)
						//console.log('subscribe', pushSubscription.toJSON());
	
						return fetch(this.registerTokenUrl, {
							method: 'POST',
							credentials: 'include',
							body: "data_token=" + JSON.stringify(pushSubscription.toJSON()),
							headers: { "Content-type": "application/x-www-form-urlencoded; charset=UTF-8" }
						}).then(function (response) {
							return response.json();
						}).then(function (jsonResponse) {
							this.subscription = pushSubscription;
							//console.log('subscribe to dek-d complete.', jsonResponse);
							this.showWelcomeMessage();
							this.createSubscribeCookie();
							resolve(jsonResponse);
						}.bind(this));
					}.bind(_this2)).catch(function (error) {
						//console.log('subscribe error.', error);
						reject(error);
					});
				});
			},
	
			unsubscribe: function unsubscribe() {
				var _this3 = this;
	
				if (!this.isSubscribe()) return false;
	
				return new Promise(function (resolve, reject) {
	
					_this3.subscription.unsubscribe().then(function (response) {
						//console.log('unsubscribe', response);
	
						fetch(this.unRegisterTokenUrl, {
							method: 'POST',
							credentials: 'include',
							body: "data_token=" + JSON.stringify(this.subscription.toJSON()),
							headers: { "Content-type": "application/x-www-form-urlencoded; charset=UTF-8" }
						}).then(function (response) {
							return response.json();
						}).then(function (jsonResponse) {
							//console.log("un-register complete", jsonResponse);
							this.removeSubscribeCookie();
							resolve(jsonResponse);
						}.bind(this));
					}.bind(_this3)).catch(function (error) {
						//console.log('Error un-subscribing', error);
						reject(error);
					});
				});
			},
	
			createSubscribeCookie: function createSubscribeCookie() {
				var now = new Date();
				var exp = Date.now() + 31536000000; // 365 day in sec
				now.setTime(exp);
				document.cookie = "issubscriber=1;expires=" + now.toGMTString() + ";path=/;domain=.dek-d.com";
			},
	
			removeSubscribeCookie: function removeSubscribeCookie() {
				document.cookie = "issubscriber=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.dek-d.com"; //clear cookie
			},
	
			showWelcomeMessage: function showWelcomeMessage() {
				this.registration.showNotification('ขอบคุณที่ติดตามเรา', {
					body: 'ต่อไปการแจ้งเตือนจะขึ้นตรงนี้นะ',
					icon: 'https://www0.dek-d.com/assets/notification/images/default-noti.png',
					tag: 'first'
				});
			}
		};
	}(window);
	
	exports.default = subscribeManager;
	function unSubscribe() {
		subscribeManager.unsubscribe();
	}
	
	function subscribe() {
		subscribeManager.subscribe();
	}
	
	window.tsub = subscribe;
	window.tunsub = unSubscribe;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(9)))

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, Promise, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   3.3.1
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  return typeof x === 'function' || typeof x === 'object' && x !== null;
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (!Array.isArray) {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	} else {
	  _isArray = Array.isArray;
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  return function () {
	    vertxNext(flush);
	  };
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(8);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  _resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        _resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      _reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      _reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    _reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return _resolve(promise, value);
	    }, function (reason) {
	      return _reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$) {
	  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$ === GET_THEN_ERROR) {
	      _reject(promise, GET_THEN_ERROR.error);
	    } else if (then$$ === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$)) {
	      handleForeignThenable(promise, maybeThenable, then$$);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function _resolve(promise, value) {
	  if (promise === value) {
	    _reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function _reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      _reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      _resolve(promise, value);
	    } else if (failed) {
	      _reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      _reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      _resolve(promise, value);
	    }, function rejectPromise(reason) {
	      _reject(promise, reason);
	    });
	  } catch (e) {
	    _reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this._input = input;
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate();
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    _reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	};
	
	Enumerator.prototype._enumerate = function () {
	  var length = this.length;
	  var _input = this._input;
	
	  for (var i = 0; this._state === PENDING && i < length; i++) {
	    this._eachEntry(_input[i], i);
	  }
	};
	
	Enumerator.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$ = c.resolve;
	
	  if (resolve$$ === resolve) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$) {
	        return resolve$$(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$(entry), i);
	  }
	};
	
	Enumerator.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      _reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  _reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve;
	Promise.reject = reject;
	Promise._setScheduler = setScheduler;
	Promise._setAsap = setAsap;
	Promise._asap = asap;
	
	Promise.prototype = {
	  constructor: Promise,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	function polyfill() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise;
	}
	
	polyfill();
	// Strange compat..
	Promise.polyfill = polyfill;
	Promise.Promise = Promise;
	
	return Promise;
	
	})));
	//# sourceMappingURL=es6-promise.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(7), (function() { return this; }())))

/***/ },
/* 8 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = global.fetch;
	}.call(global));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), (function() { return this; }())))

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n\t\t<div class="', '">\n\t\t\t<div class="', '">ให้เราแจ้งคุณเมื่อมีบทความมาใหม่</div>\n\t\t\t<div class="', '">กดติดตามบทความหมวด <span class="main-cat-txt">', '</span> ที่นี่</div>\n\t\t\t<a href="#" class="dekdbutton clickt0-subscribe ', '" onclick=', '><i class=" fa icon-fa-bell"></i> ติดตาม</a>\n\t\t\t<i class="', '" onclick=', '></i>\n\t\t\t<div class="', '">\n\t\t\t\t<a class="', '" href="https://goo.gl/8h8QRh" target="_blank" title="อ่านรายละเอียดเการแจ้งเตือนพิ่มเติม">อ่านรายละเอียดเพิ่มเติม <i class="icon-fa-angle-right"></i></a>\n\t\t\t</div>\n\t\t</div>\n\t\t'], ['\n\t\t<div class="', '">\n\t\t\t<div class="', '">ให้เราแจ้งคุณเมื่อมีบทความมาใหม่</div>\n\t\t\t<div class="', '">กดติดตามบทความหมวด <span class="main-cat-txt">', '</span> ที่นี่</div>\n\t\t\t<a href="#" class="dekdbutton clickt0-subscribe ', '" onclick=', '><i class=" fa icon-fa-bell"></i> ติดตาม</a>\n\t\t\t<i class="', '" onclick=', '></i>\n\t\t\t<div class="', '">\n\t\t\t\t<a class="', '" href="https://goo.gl/8h8QRh" target="_blank" title="อ่านรายละเอียดเการแจ้งเตือนพิ่มเติม">อ่านรายละเอียดเพิ่มเติม <i class="icon-fa-angle-right"></i></a>\n\t\t\t</div>\n\t\t</div>\n\t\t']);
	
	var _noticeStyle = __webpack_require__(11);
	
	var _noticeStyle2 = _interopRequireDefault(_noticeStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var yo = __webpack_require__(25);
	var csjs = __webpack_require__(12);
	var insertCss = __webpack_require__(35);
	
	
	insertCss(csjs.getCss(_noticeStyle2.default));
	
	var NoticePopup = function () {
		function NoticePopup(mainCategory) {
			var categoryName = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
			_classCallCheck(this, NoticePopup);
	
			this.mainCategory = mainCategory;
			this.name = categoryName;
			this.subscribeCallback = [];
			this.closeCallback = [];
			this.template = this.getTemplate();
			document.body.appendChild(this.template);
			this.hide();
	
			return this;
		}
	
		_createClass(NoticePopup, [{
			key: 'getTemplate',
			value: function getTemplate() {
				var _this = this;
	
				return yo(_templateObject, _noticeStyle2.default['notify-popup-wrapper'], _noticeStyle2.default['notify-popup-title'], _noticeStyle2.default['notify-popup-desc'], this.name, _noticeStyle2.default.dekdbutton, function (e) {
					_this.subscribe(e);
				}, _noticeStyle2.default['close-button'], function () {
					_this.close();
				}, _noticeStyle2.default['notify-popup-more-container'], _noticeStyle2.default['notify-popup-more']);
			}
		}, {
			key: 'subscribe',
			value: function subscribe(e) {
				e.preventDefault();
				//console.log`clicked on subscribe ${this.name}`;
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = this.subscribeCallback[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var callback = _step.value;
	
						callback(this, e);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
		}, {
			key: 'close',
			value: function close() {
				//console.log('popup - close');
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = this.closeCallback[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var callback = _step2.value;
	
						callback(this);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				this.template.classList.remove(_noticeStyle2.default.show);
				this.template.classList.add(_noticeStyle2.default.close);
			}
		}, {
			key: 'show',
			value: function show() {
				//console.log('popup - show');
				this.template.classList.add(_noticeStyle2.default.show);
				this.template.classList.remove(_noticeStyle2.default.hide);
				this.template.classList.remove(_noticeStyle2.default.close);
			}
		}, {
			key: 'hide',
			value: function hide() {
				//console.log('popup - hide');
				this.template.classList.remove(_noticeStyle2.default.show);
				this.template.classList.add(_noticeStyle2.default.hide);
			}
		}, {
			key: 'onSubscribeClicked',
			value: function onSubscribeClicked(callback) {
				this.subscribeCallback.push(callback);
			}
		}, {
			key: 'onCloseClicked',
			value: function onCloseClicked(callback) {
				this.closeCallback.push(callback);
			}
		}, {
			key: 'setCategoryName',
			value: function setCategoryName(name) {
				this.name = name;
				yo.update(this.template, this.getTemplate());
			}
		}]);
	
		return NoticePopup;
	}();
	
	exports.default = NoticePopup;
	
	
	__webpack_require__(35)(csjs.getCss(_noticeStyle2.default));

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n\n\t.notify-popup-wrapper {\n\t\tbackground: #FFF;\n\t\tposition: fixed;\n\t\twidth: 100%;\n\t\ttop: -', ';\n\t\tz-index: 10;\n\t\ttext-align: center;\n\t\tpadding: 15px 10px 10px 10px;\n\t\tbox-sizing: border-box;\n\t\tbox-shadow: 0 1px 3px rgba(0,0,0,0.2);\n\t\theight: ', ';\n\t}\n\t.notify-popup-wrapper .notify-popup-title {\n\t\tfont-size: 16px;\n\t\tcolor: #493f34;\n\t\tfont-weight: bold;\n\t}\n\t.notify-popup-wrapper .notify-popup-desc {\n\t\tfont-size: 13px;\n\t\tcolor: #81684d;\n\t\tline-height: 20px;\n\t}\n\t.notify-popup-wrapper .close-button {\n\t\tposition: absolute;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tz-index: 21;\n\t\ttop: 10px;\n\t\tright: 10px;\n\t\tcursor: pointer;\n\t}\n\t.notify-popup-wrapper .close-button:before, .notify-popup-wrapper .close-button:after {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\theight: 2px;\n\t\twidth: 100%;\n\t\ttop: 50%;\n\t\tleft: 0;\n\t\tmargin-top: -1px;\n\t\tbackground: #cfc198;\n\t}\n\t.notify-popup-wrapper .close-button:before {\n\t\t-webkit-transform: rotate(45deg);\n\t\t-moz-transform: rotate(45deg);\n\t\t-ms-transform: rotate(45deg);\n\t\t-o-transform: rotate(45deg);\n\t\ttransform: rotate(45deg);\n\t}\n\t.notify-popup-wrapper .close-button:after {\n\t\t-webkit-transform: rotate(-45deg);\n\t\t-moz-transform: rotate(-45deg);\n\t\t-ms-transform: rotate(-45deg);\n\t\t-o-transform: rotate(-45deg);\n\t\ttransform: rotate(-45deg);\n\t}\n\t.notify-popup-wrapper .close-button:hover:before, .notify-popup-wrapper .close-button:hover:after {\n\t\tbackground: #706150;\n\t}\n\t.notify-popup-wrapper .dekdbutton {\n\t\tpadding: 7px 20px;\n\t\theight: 30px;\n\t\ttext-shadow: none;\n\t\tfont-size: 13px;\n\t\tborder-bottom: none;\n\t\tborder: solid 1px #de8022;\n\t\tmargin-top: 5px;\n\t\tcolor: #fff;\n    \ttext-decoration: none;\n\t}\n\t.notify-popup-wrapper .dekdbutton:active {\n\t\tborder: solid 1px #de8022;\n\t\tbox-shadow: none;\n\t}\n\t.notify-popup-more-container {\n\t\ttext-align: center;\n\t\tpadding: 5px;\n\t}\n\t.notify-popup-more {\n\t\tcolor: #cc6600;\n\t\tfont-size: 11px;\n\t}\n\t.notify-popup-more:link {\n\t\tcolor: #cc6600;\n\t\ttext-decoration: none;\n\t}\n\t\n\t.container {\n\t\tposition: fixed;\n\t\tbottom: 0px;\n\t\tright: 0px;\n\t\twidth: 300px;\n\t\theight: ', ';\n\t\tbackground-color: red;\n\t\tz-index: 1000;\n\t}\n\t\n\t.show {\n\t\ttop: ', ';\n\t\tdisplay: block;\n\t\tvisibility: visible;\n\t}\n\t\n\t.hide {\n\t\ttop: -', ';\n\t}\n\t\n\t.close {\n\t\ttop: -', ';\n\t\tanimation-duration: 0.3s;\n  \t\tanimation-name: slide-up;\n\t}\n\t\n\t\n\t\n\t@media only screen and (min-width: 768px)  {\n\t\t.notify-popup-wrapper {\n\t\t\twidth: 320px;\n\t\t\tbottom: -', ';\n\t\t\tright: 10px;\n\t\t\ttop: inherit;\n\t\t\tbox-shadow: 0 0px 7px rgba(0,0,0,0.4);\n\t\t}\n\t\t\n\t\t.show {\n\t\t\tbottom: 0;\n\t\t\tdisplay: block;\n\t\t\tvisibility: visible;\n\t\t}\n\t\t\n\t\t.hide {\n\t\t\tbottom: -', ';\n\t\t}\n\t\t\n\t\t.close {\n\t\t\tbottom: -', ';\n\t\t\tanimation-duration: 0.3s;\n\t\t\tanimation-name: slide-down;\n\t\t}\n\t}\n\n\t\n\t\n\t\n\t@keyframes slide-up {\n\t\tfrom {\n\t\t\ttop: 0px;\n\t\t}\n\t\t\n\t\tto {\n\t\t\ttop: -', ';\n\t\t}\n\t}\n\t\n\t@keyframes slide-down {\n\t\tfrom {\n\t\t\tbottom: 0px;\n\t\t}\n\t\t\n\t\tto {\n\t\t\tbottom: -', ';\n\t\t}\n\t}\n\t\n'], ['\n\n\t.notify-popup-wrapper {\n\t\tbackground: #FFF;\n\t\tposition: fixed;\n\t\twidth: 100%;\n\t\ttop: -', ';\n\t\tz-index: 10;\n\t\ttext-align: center;\n\t\tpadding: 15px 10px 10px 10px;\n\t\tbox-sizing: border-box;\n\t\tbox-shadow: 0 1px 3px rgba(0,0,0,0.2);\n\t\theight: ', ';\n\t}\n\t.notify-popup-wrapper .notify-popup-title {\n\t\tfont-size: 16px;\n\t\tcolor: #493f34;\n\t\tfont-weight: bold;\n\t}\n\t.notify-popup-wrapper .notify-popup-desc {\n\t\tfont-size: 13px;\n\t\tcolor: #81684d;\n\t\tline-height: 20px;\n\t}\n\t.notify-popup-wrapper .close-button {\n\t\tposition: absolute;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tz-index: 21;\n\t\ttop: 10px;\n\t\tright: 10px;\n\t\tcursor: pointer;\n\t}\n\t.notify-popup-wrapper .close-button:before, .notify-popup-wrapper .close-button:after {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\theight: 2px;\n\t\twidth: 100%;\n\t\ttop: 50%;\n\t\tleft: 0;\n\t\tmargin-top: -1px;\n\t\tbackground: #cfc198;\n\t}\n\t.notify-popup-wrapper .close-button:before {\n\t\t-webkit-transform: rotate(45deg);\n\t\t-moz-transform: rotate(45deg);\n\t\t-ms-transform: rotate(45deg);\n\t\t-o-transform: rotate(45deg);\n\t\ttransform: rotate(45deg);\n\t}\n\t.notify-popup-wrapper .close-button:after {\n\t\t-webkit-transform: rotate(-45deg);\n\t\t-moz-transform: rotate(-45deg);\n\t\t-ms-transform: rotate(-45deg);\n\t\t-o-transform: rotate(-45deg);\n\t\ttransform: rotate(-45deg);\n\t}\n\t.notify-popup-wrapper .close-button:hover:before, .notify-popup-wrapper .close-button:hover:after {\n\t\tbackground: #706150;\n\t}\n\t.notify-popup-wrapper .dekdbutton {\n\t\tpadding: 7px 20px;\n\t\theight: 30px;\n\t\ttext-shadow: none;\n\t\tfont-size: 13px;\n\t\tborder-bottom: none;\n\t\tborder: solid 1px #de8022;\n\t\tmargin-top: 5px;\n\t\tcolor: #fff;\n    \ttext-decoration: none;\n\t}\n\t.notify-popup-wrapper .dekdbutton:active {\n\t\tborder: solid 1px #de8022;\n\t\tbox-shadow: none;\n\t}\n\t.notify-popup-more-container {\n\t\ttext-align: center;\n\t\tpadding: 5px;\n\t}\n\t.notify-popup-more {\n\t\tcolor: #cc6600;\n\t\tfont-size: 11px;\n\t}\n\t.notify-popup-more:link {\n\t\tcolor: #cc6600;\n\t\ttext-decoration: none;\n\t}\n\t\n\t.container {\n\t\tposition: fixed;\n\t\tbottom: 0px;\n\t\tright: 0px;\n\t\twidth: 300px;\n\t\theight: ', ';\n\t\tbackground-color: red;\n\t\tz-index: 1000;\n\t}\n\t\n\t.show {\n\t\ttop: ', ';\n\t\tdisplay: block;\n\t\tvisibility: visible;\n\t}\n\t\n\t.hide {\n\t\ttop: -', ';\n\t}\n\t\n\t.close {\n\t\ttop: -', ';\n\t\tanimation-duration: 0.3s;\n  \t\tanimation-name: slide-up;\n\t}\n\t\n\t\n\t\n\t@media only screen and (min-width: 768px)  {\n\t\t.notify-popup-wrapper {\n\t\t\twidth: 320px;\n\t\t\tbottom: -', ';\n\t\t\tright: 10px;\n\t\t\ttop: inherit;\n\t\t\tbox-shadow: 0 0px 7px rgba(0,0,0,0.4);\n\t\t}\n\t\t\n\t\t.show {\n\t\t\tbottom: 0;\n\t\t\tdisplay: block;\n\t\t\tvisibility: visible;\n\t\t}\n\t\t\n\t\t.hide {\n\t\t\tbottom: -', ';\n\t\t}\n\t\t\n\t\t.close {\n\t\t\tbottom: -', ';\n\t\t\tanimation-duration: 0.3s;\n\t\t\tanimation-name: slide-down;\n\t\t}\n\t}\n\n\t\n\t\n\t\n\t@keyframes slide-up {\n\t\tfrom {\n\t\t\ttop: 0px;\n\t\t}\n\t\t\n\t\tto {\n\t\t\ttop: -', ';\n\t\t}\n\t}\n\t\n\t@keyframes slide-down {\n\t\tfrom {\n\t\t\tbottom: 0px;\n\t\t}\n\t\t\n\t\tto {\n\t\t\tbottom: -', ';\n\t\t}\n\t}\n\t\n']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var csjs = __webpack_require__(12);
	
	var noticeHeight = exports.noticeHeight = '110px';
	var noticeHeightHide = exports.noticeHeightHide = '115px';
	var toolbarHeight = exports.toolbarHeight = '40px';
	var notice = csjs(_templateObject, noticeHeight, noticeHeight, noticeHeight, toolbarHeight, noticeHeight, noticeHeight, noticeHeightHide, noticeHeight, noticeHeight, noticeHeight, noticeHeight);
	
	exports.default = notice;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var csjs = __webpack_require__(13);
	
	module.exports = csjs;
	module.exports.csjs = csjs;
	module.exports.getCss = __webpack_require__(23);


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(14);


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var extractExtends = __webpack_require__(15);
	var isComposition = __webpack_require__(16).isComposition;
	var buildExports = __webpack_require__(17);
	var scopify = __webpack_require__(18);
	var cssKey = __webpack_require__(22);
	
	module.exports = function csjsHandler(strings) {
	  // Fast path to prevent arguments deopt
	  var values = Array(arguments.length - 1);
	  for (var i = 1; i < arguments.length; i++) {
	    values[i - 1] = arguments[i];
	  }
	  var css = joiner(strings, values.map(selectorize));
	
	  var ignores = values.reduce(function(acc, val) {
	    if (isComposition(val)) {
	      val.classNames.forEach(function(name, i) {
	        acc[name] = val.unscoped[i];
	      });
	    }
	    return acc;
	  }, {});
	
	  var scoped = scopify(css, ignores);
	  var extracted = extractExtends(scoped.css);
	
	  var localClasses = without(scoped.classes, ignores);
	  var localKeyframes = without(scoped.keyframes, ignores);
	  var compositions = extracted.compositions;
	
	  var exports = buildExports(localClasses, localKeyframes, compositions);
	
	  return Object.defineProperty(exports, cssKey, {
	    enumerable: false,
	    configurable: false,
	    writeable: false,
	    value: extracted.css
	  });
	};
	
	/**
	 * Replaces class compositions with comma seperated class selectors
	 * @param  value - the potential class composition
	 * @return       - the original value or the selectorized class composition
	 */
	function selectorize(value) {
	  return isComposition(value) ? value.selector : value;
	}
	
	/**
	 * Joins template string literals and values
	 * @param  {array} strings - array of strings
	 * @param  {array} values  - array of values
	 * @return {string}        - strings and values joined
	 */
	function joiner(strings, values) {
	  return strings.map(function(str, i) {
	    return (i !== values.length) ? str + values[i] : str;
	  }).join('');
	}
	
	/**
	 * Returns first object without keys of second
	 * @param  {object} obj      - source object
	 * @param  {object} unwanted - object with unwanted keys
	 * @return {object}          - first object without unwanted keys
	 */
	function without(obj, unwanted) {
	  return Object.keys(obj).reduce(function(acc, key) {
	    if (!unwanted[key]) {
	      acc[key] = obj[key];
	    }
	    return acc;
	  }, {});
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var makeComposition = __webpack_require__(16).makeComposition;
	
	var regex = /\.([^\s]+)(\s+)(extends\s+)(\.[^{]+)/g;
	
	module.exports = function extractExtends(css) {
	  var found, matches = [];
	  while (found = regex.exec(css)) {
	    matches.unshift(found);
	  }
	
	  function extractCompositions(acc, match) {
	    var extendee = getClassName(match[1]);
	    var keyword = match[3];
	    var extended = match[4];
	
	    // remove from output css
	    var index = match.index + match[1].length + match[2].length;
	    var len = keyword.length + extended.length;
	    acc.css = acc.css.slice(0, index) + " " + acc.css.slice(index + len + 1);
	
	    var extendedClasses = splitter(extended);
	
	    extendedClasses.forEach(function(className) {
	      if (!acc.compositions[extendee]) {
	        acc.compositions[extendee] = {};
	      }
	      if (!acc.compositions[className]) {
	        acc.compositions[className] = {};
	      }
	      acc.compositions[extendee][className] = acc.compositions[className];
	    });
	    return acc;
	  }
	
	  return matches.reduce(extractCompositions, {
	    css: css,
	    compositions: {}
	  });
	
	};
	
	function splitter(match) {
	  return match.split(',').map(getClassName);
	}
	
	function getClassName(str) {
	  var trimmed = str.trim();
	  return trimmed[0] === '.' ? trimmed.substr(1) : trimmed;
	}


/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  makeComposition: makeComposition,
	  isComposition: isComposition
	};
	
	/**
	 * Returns an immutable composition object containing the given class names
	 * @param  {array} classNames - The input array of class names
	 * @return {Composition}      - An immutable object that holds multiple
	 *                              representations of the class composition
	 */
	function makeComposition(classNames, unscoped, isAnimation) {
	  var classString = classNames.join(' ');
	  return Object.create(Composition.prototype, {
	    classNames: { // the original array of class names
	      value: Object.freeze(classNames),
	      configurable: false,
	      writable: false,
	      enumerable: true
	    },
	    unscoped: { // the original array of class names
	      value: Object.freeze(unscoped),
	      configurable: false,
	      writable: false,
	      enumerable: true
	    },
	    className: { // space-separated class string for use in HTML
	      value: classString,
	      configurable: false,
	      writable: false,
	      enumerable: true
	    },
	    selector: { // comma-separated, period-prefixed string for use in CSS
	      value: classNames.map(function(name) {
	        return isAnimation ? name : '.' + name;
	      }).join(', '),
	      configurable: false,
	      writable: false,
	      enumerable: true
	    },
	    toString: { // toString() method, returns class string for use in HTML
	      value: function() {
	        return classString;
	      },
	      configurable: false,
	      writeable: false,
	      enumerable: false
	    }
	  });
	}
	
	/**
	 * Returns whether the input value is a Composition
	 * @param value      - value to check
	 * @return {boolean} - whether value is a Composition or not
	 */
	function isComposition(value) {
	  return value instanceof Composition;
	}
	
	/**
	 * Private constructor for use in `instanceof` checks
	 */
	function Composition() {}


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var makeComposition = __webpack_require__(16).makeComposition;
	
	module.exports = function createExports(classes, keyframes, compositions) {
	  var keyframesObj = Object.keys(keyframes).reduce(function(acc, key) {
	    var val = keyframes[key];
	    acc[val] = makeComposition([key], [val], true);
	    return acc;
	  }, {});
	
	  var exports = Object.keys(classes).reduce(function(acc, key) {
	    var val = classes[key];
	    var composition = compositions[key];
	    var extended = composition ? getClassChain(composition) : [];
	    var allClasses = [key].concat(extended);
	    var unscoped = allClasses.map(function(name) {
	      return classes[name] ? classes[name] : name;
	    });
	    acc[val] = makeComposition(allClasses, unscoped);
	    return acc;
	  }, keyframesObj);
	
	  return exports;
	}
	
	function getClassChain(obj) {
	  var visited = {}, acc = [];
	
	  function traverse(obj) {
	    return Object.keys(obj).forEach(function(key) {
	      if (!visited[key]) {
	        visited[key] = true;
	        acc.push(key);
	        traverse(obj[key]);
	      }
	    });
	  }
	
	  traverse(obj);
	  return acc;
	}


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var fileScoper = __webpack_require__(19);
	
	var findClasses = /(\.)(?!\d)([^\s\.,{\[>+~#:)]*)(?![^{]*})/.source;
	var findKeyframes = /(@\S*keyframes\s*)([^{\s]*)/.source;
	var ignoreComments = /(?!(?:[^*/]|\*[^/]|\/[^*])*\*+\/)/.source;
	
	var classRegex = new RegExp(findClasses + ignoreComments, 'g');
	var keyframesRegex = new RegExp(findKeyframes + ignoreComments, 'g');
	
	module.exports = scopify;
	
	function scopify(css, ignores) {
	  var makeScopedName = fileScoper(css);
	  var replacers = {
	    classes: classRegex,
	    keyframes: keyframesRegex
	  };
	
	  function scopeCss(result, key) {
	    var replacer = replacers[key];
	    function replaceFn(fullMatch, prefix, name) {
	      var scopedName = ignores[name] ? name : makeScopedName(name);
	      result[key][scopedName] = name;
	      return prefix + scopedName;
	    }
	    return {
	      css: result.css.replace(replacer, replaceFn),
	      keyframes: result.keyframes,
	      classes: result.classes
	    };
	  }
	
	  var result = Object.keys(replacers).reduce(scopeCss, {
	    css: css,
	    keyframes: {},
	    classes: {}
	  });
	
	  return replaceAnimations(result);
	}
	
	function replaceAnimations(result) {
	  var animations = Object.keys(result.keyframes).reduce(function(acc, key) {
	    acc[result.keyframes[key]] = key;
	    return acc;
	  }, {});
	  var unscoped = Object.keys(animations);
	
	  if (unscoped.length) {
	    var regexStr = '((?:animation|animation-name)\\s*:[^};]*)('
	      + unscoped.join('|') + ')([;\\s])' + ignoreComments;
	    var regex = new RegExp(regexStr, 'g');
	
	    var replaced = result.css.replace(regex, function(match, preamble, name, ending) {
	      return preamble + animations[name] + ending;
	    });
	
	    return {
	      css: replaced,
	      keyframes: result.keyframes,
	      classes: result.classes
	    }
	  }
	
	  return result;
	}


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var encode = __webpack_require__(20);
	var hash = __webpack_require__(21);
	
	module.exports = function fileScoper(fileSrc) {
	  var suffix = encode(hash(fileSrc));
	
	  return function scopedName(name) {
	    return name + '_' + suffix;
	  }
	};


/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * base62 encode implementation based on base62 module:
	 * https://github.com/andrew/base62.js
	 */
	
	var CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	
	module.exports = function encode(integer) {
	  if (integer === 0) {
	    return '0';
	  }
	  var str = '';
	  while (integer > 0) {
	    str = CHARS[integer % 62] + str;
	    integer = Math.floor(integer / 62);
	  }
	  return str;
	};


/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * djb2 string hash implementation based on string-hash module:
	 * https://github.com/darkskyapp/string-hash
	 */
	
	module.exports = function hashStr(str) {
	  var hash = 5381;
	  var i = str.length;
	
	  while (i) {
	    hash = (hash * 33) ^ str.charCodeAt(--i)
	  }
	  return hash >>> 0;
	};


/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * CSS identifiers with whitespace are invalid
	 * Hence this key will not cause a collision
	 */
	
	module.exports = ' css ';


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(24);


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var cssKey = __webpack_require__(22);
	
	module.exports = function getCss(csjs) {
	  return csjs[cssKey];
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var bel = __webpack_require__(26) // turns template tag into DOM elements
	var morphdom = __webpack_require__(33) // efficiently diffs + morphs two DOM elements
	var defaultEvents = __webpack_require__(34) // default events to be copied when dom elements update
	
	module.exports = bel
	
	// TODO move this + defaultEvents to a new module once we receive more feedback
	module.exports.update = function (fromNode, toNode, opts) {
	  if (!opts) opts = {}
	  if (opts.events !== false) {
	    if (!opts.onBeforeElUpdated) opts.onBeforeElUpdated = copier
	  }
	
	  return morphdom(fromNode, toNode, opts)
	
	  // morphdom only copies attributes. we decided we also wanted to copy events
	  // that can be set via attributes
	  function copier (f, t) {
	    // copy events:
	    var events = opts.events || defaultEvents
	    for (var i = 0; i < events.length; i++) {
	      var ev = events[i]
	      if (t[ev]) { // if new element has a whitelisted attribute
	        f[ev] = t[ev] // update existing element
	      } else if (f[ev]) { // if existing element has it and new one doesnt
	        f[ev] = undefined // remove it from existing element
	      }
	    }
	    // copy values for form elements
	    if ((f.nodeName === 'INPUT' && f.type !== 'file') || f.nodeName === 'SELECT') {
	      if (t.getAttribute('value') === null) t.value = f.value
	    } else if (f.nodeName === 'TEXTAREA') {
	      if (t.getAttribute('value') === null) f.value = t.value
	    }
	  }
	}


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(27)
	var hyperx = __webpack_require__(29)
	var onload = __webpack_require__(31)
	
	var SVGNS = 'http://www.w3.org/2000/svg'
	var XLINKNS = 'http://www.w3.org/1999/xlink'
	
	var BOOL_PROPS = {
	  autofocus: 1,
	  checked: 1,
	  defaultchecked: 1,
	  disabled: 1,
	  formnovalidate: 1,
	  indeterminate: 1,
	  readonly: 1,
	  required: 1,
	  selected: 1,
	  willvalidate: 1
	}
	var SVG_TAGS = [
	  'svg',
	  'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor',
	  'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile',
	  'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColorMatrix',
	  'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting',
	  'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB',
	  'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode',
	  'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting',
	  'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face',
	  'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri',
	  'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line',
	  'linearGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath',
	  'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect',
	  'set', 'stop', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref',
	  'tspan', 'use', 'view', 'vkern'
	]
	
	function belCreateElement (tag, props, children) {
	  var el
	
	  // If an svg tag, it needs a namespace
	  if (SVG_TAGS.indexOf(tag) !== -1) {
	    props.namespace = SVGNS
	  }
	
	  // If we are using a namespace
	  var ns = false
	  if (props.namespace) {
	    ns = props.namespace
	    delete props.namespace
	  }
	
	  // Create the element
	  if (ns) {
	    el = document.createElementNS(ns, tag)
	  } else {
	    el = document.createElement(tag)
	  }
	
	  // If adding onload events
	  if (props.onload || props.onunload) {
	    var load = props.onload || function () {}
	    var unload = props.onunload || function () {}
	    onload(el, function belOnload () {
	      load(el)
	    }, function belOnunload () {
	      unload(el)
	    },
	    // We have to use non-standard `caller` to find who invokes `belCreateElement`
	    belCreateElement.caller.caller.caller)
	    delete props.onload
	    delete props.onunload
	  }
	
	  // Create the properties
	  for (var p in props) {
	    if (props.hasOwnProperty(p)) {
	      var key = p.toLowerCase()
	      var val = props[p]
	      // Normalize className
	      if (key === 'classname') {
	        key = 'class'
	        p = 'class'
	      }
	      // The for attribute gets transformed to htmlFor, but we just set as for
	      if (p === 'htmlFor') {
	        p = 'for'
	      }
	      // If a property is boolean, set itself to the key
	      if (BOOL_PROPS[key]) {
	        if (val === 'true') val = key
	        else if (val === 'false') continue
	      }
	      // If a property prefers being set directly vs setAttribute
	      if (key.slice(0, 2) === 'on') {
	        el[p] = val
	      } else {
	        if (ns) {
	          if (p === 'xlink:href') {
	            el.setAttributeNS(XLINKNS, p, val)
	          } else if (/^xmlns($|:)/i.test(p)) {
	            // skip xmlns definitions
	          } else {
	            el.setAttributeNS(null, p, val)
	          }
	        } else {
	          el.setAttribute(p, val)
	        }
	      }
	    }
	  }
	
	  function appendChild (childs) {
	    if (!Array.isArray(childs)) return
	    for (var i = 0; i < childs.length; i++) {
	      var node = childs[i]
	      if (Array.isArray(node)) {
	        appendChild(node)
	        continue
	      }
	
	      if (typeof node === 'number' ||
	        typeof node === 'boolean' ||
	        node instanceof Date ||
	        node instanceof RegExp) {
	        node = node.toString()
	      }
	
	      if (typeof node === 'string') {
	        if (el.lastChild && el.lastChild.nodeName === '#text') {
	          el.lastChild.nodeValue += node
	          continue
	        }
	        node = document.createTextNode(node)
	      }
	
	      if (node && node.nodeType) {
	        el.appendChild(node)
	      }
	    }
	  }
	  appendChild(children)
	
	  return el
	}
	
	module.exports = hyperx(belCreateElement)
	module.exports.default = module.exports
	module.exports.createElement = belCreateElement


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
	    typeof window !== 'undefined' ? window : {}
	var minDoc = __webpack_require__(28);
	
	if (typeof document !== 'undefined') {
	    module.exports = document;
	} else {
	    var doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
	
	    if (!doccy) {
	        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
	    }
	
	    module.exports = doccy;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 28 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var attrToProp = __webpack_require__(30)
	
	var VAR = 0, TEXT = 1, OPEN = 2, CLOSE = 3, ATTR = 4
	var ATTR_KEY = 5, ATTR_KEY_W = 6
	var ATTR_VALUE_W = 7, ATTR_VALUE = 8
	var ATTR_VALUE_SQ = 9, ATTR_VALUE_DQ = 10
	var ATTR_EQ = 11, ATTR_BREAK = 12
	
	module.exports = function (h, opts) {
	  h = attrToProp(h)
	  if (!opts) opts = {}
	  var concat = opts.concat || function (a, b) {
	    return String(a) + String(b)
	  }
	
	  return function (strings) {
	    var state = TEXT, reg = ''
	    var arglen = arguments.length
	    var parts = []
	
	    for (var i = 0; i < strings.length; i++) {
	      if (i < arglen - 1) {
	        var arg = arguments[i+1]
	        var p = parse(strings[i])
	        var xstate = state
	        if (xstate === ATTR_VALUE_DQ) xstate = ATTR_VALUE
	        if (xstate === ATTR_VALUE_SQ) xstate = ATTR_VALUE
	        if (xstate === ATTR_VALUE_W) xstate = ATTR_VALUE
	        if (xstate === ATTR) xstate = ATTR_KEY
	        p.push([ VAR, xstate, arg ])
	        parts.push.apply(parts, p)
	      } else parts.push.apply(parts, parse(strings[i]))
	    }
	
	    var tree = [null,{},[]]
	    var stack = [[tree,-1]]
	    for (var i = 0; i < parts.length; i++) {
	      var cur = stack[stack.length-1][0]
	      var p = parts[i], s = p[0]
	      if (s === OPEN && /^\//.test(p[1])) {
	        var ix = stack[stack.length-1][1]
	        if (stack.length > 1) {
	          stack.pop()
	          stack[stack.length-1][0][2][ix] = h(
	            cur[0], cur[1], cur[2].length ? cur[2] : undefined
	          )
	        }
	      } else if (s === OPEN) {
	        var c = [p[1],{},[]]
	        cur[2].push(c)
	        stack.push([c,cur[2].length-1])
	      } else if (s === ATTR_KEY || (s === VAR && p[1] === ATTR_KEY)) {
	        var key = ''
	        var copyKey
	        for (; i < parts.length; i++) {
	          if (parts[i][0] === ATTR_KEY) {
	            key = concat(key, parts[i][1])
	          } else if (parts[i][0] === VAR && parts[i][1] === ATTR_KEY) {
	            if (typeof parts[i][2] === 'object' && !key) {
	              for (copyKey in parts[i][2]) {
	                if (parts[i][2].hasOwnProperty(copyKey) && !cur[1][copyKey]) {
	                  cur[1][copyKey] = parts[i][2][copyKey]
	                }
	              }
	            } else {
	              key = concat(key, parts[i][2])
	            }
	          } else break
	        }
	        if (parts[i][0] === ATTR_EQ) i++
	        var j = i
	        for (; i < parts.length; i++) {
	          if (parts[i][0] === ATTR_VALUE || parts[i][0] === ATTR_KEY) {
	            if (!cur[1][key]) cur[1][key] = strfn(parts[i][1])
	            else cur[1][key] = concat(cur[1][key], parts[i][1])
	          } else if (parts[i][0] === VAR
	          && (parts[i][1] === ATTR_VALUE || parts[i][1] === ATTR_KEY)) {
	            if (!cur[1][key]) cur[1][key] = strfn(parts[i][2])
	            else cur[1][key] = concat(cur[1][key], parts[i][2])
	          } else {
	            if (key.length && !cur[1][key] && i === j
	            && (parts[i][0] === CLOSE || parts[i][0] === ATTR_BREAK)) {
	              // https://html.spec.whatwg.org/multipage/infrastructure.html#boolean-attributes
	              // empty string is falsy, not well behaved value in browser
	              cur[1][key] = key.toLowerCase()
	            }
	            break
	          }
	        }
	      } else if (s === ATTR_KEY) {
	        cur[1][p[1]] = true
	      } else if (s === VAR && p[1] === ATTR_KEY) {
	        cur[1][p[2]] = true
	      } else if (s === CLOSE) {
	        if (selfClosing(cur[0]) && stack.length) {
	          var ix = stack[stack.length-1][1]
	          stack.pop()
	          stack[stack.length-1][0][2][ix] = h(
	            cur[0], cur[1], cur[2].length ? cur[2] : undefined
	          )
	        }
	      } else if (s === VAR && p[1] === TEXT) {
	        if (p[2] === undefined || p[2] === null) p[2] = ''
	        else if (!p[2]) p[2] = concat('', p[2])
	        if (Array.isArray(p[2][0])) {
	          cur[2].push.apply(cur[2], p[2])
	        } else {
	          cur[2].push(p[2])
	        }
	      } else if (s === TEXT) {
	        cur[2].push(p[1])
	      } else if (s === ATTR_EQ || s === ATTR_BREAK) {
	        // no-op
	      } else {
	        throw new Error('unhandled: ' + s)
	      }
	    }
	
	    if (tree[2].length > 1 && /^\s*$/.test(tree[2][0])) {
	      tree[2].shift()
	    }
	
	    if (tree[2].length > 2
	    || (tree[2].length === 2 && /\S/.test(tree[2][1]))) {
	      throw new Error(
	        'multiple root elements must be wrapped in an enclosing tag'
	      )
	    }
	    if (Array.isArray(tree[2][0]) && typeof tree[2][0][0] === 'string'
	    && Array.isArray(tree[2][0][2])) {
	      tree[2][0] = h(tree[2][0][0], tree[2][0][1], tree[2][0][2])
	    }
	    return tree[2][0]
	
	    function parse (str) {
	      var res = []
	      if (state === ATTR_VALUE_W) state = ATTR
	      for (var i = 0; i < str.length; i++) {
	        var c = str.charAt(i)
	        if (state === TEXT && c === '<') {
	          if (reg.length) res.push([TEXT, reg])
	          reg = ''
	          state = OPEN
	        } else if (c === '>' && !quot(state)) {
	          if (state === OPEN) {
	            res.push([OPEN,reg])
	          } else if (state === ATTR_KEY) {
	            res.push([ATTR_KEY,reg])
	          } else if (state === ATTR_VALUE && reg.length) {
	            res.push([ATTR_VALUE,reg])
	          }
	          res.push([CLOSE])
	          reg = ''
	          state = TEXT
	        } else if (state === TEXT) {
	          reg += c
	        } else if (state === OPEN && /\s/.test(c)) {
	          res.push([OPEN, reg])
	          reg = ''
	          state = ATTR
	        } else if (state === OPEN) {
	          reg += c
	        } else if (state === ATTR && /[\w-]/.test(c)) {
	          state = ATTR_KEY
	          reg = c
	        } else if (state === ATTR && /\s/.test(c)) {
	          if (reg.length) res.push([ATTR_KEY,reg])
	          res.push([ATTR_BREAK])
	        } else if (state === ATTR_KEY && /\s/.test(c)) {
	          res.push([ATTR_KEY,reg])
	          reg = ''
	          state = ATTR_KEY_W
	        } else if (state === ATTR_KEY && c === '=') {
	          res.push([ATTR_KEY,reg],[ATTR_EQ])
	          reg = ''
	          state = ATTR_VALUE_W
	        } else if (state === ATTR_KEY) {
	          reg += c
	        } else if ((state === ATTR_KEY_W || state === ATTR) && c === '=') {
	          res.push([ATTR_EQ])
	          state = ATTR_VALUE_W
	        } else if ((state === ATTR_KEY_W || state === ATTR) && !/\s/.test(c)) {
	          res.push([ATTR_BREAK])
	          if (/[\w-]/.test(c)) {
	            reg += c
	            state = ATTR_KEY
	          } else state = ATTR
	        } else if (state === ATTR_VALUE_W && c === '"') {
	          state = ATTR_VALUE_DQ
	        } else if (state === ATTR_VALUE_W && c === "'") {
	          state = ATTR_VALUE_SQ
	        } else if (state === ATTR_VALUE_DQ && c === '"') {
	          res.push([ATTR_VALUE,reg],[ATTR_BREAK])
	          reg = ''
	          state = ATTR
	        } else if (state === ATTR_VALUE_SQ && c === "'") {
	          res.push([ATTR_VALUE,reg],[ATTR_BREAK])
	          reg = ''
	          state = ATTR
	        } else if (state === ATTR_VALUE_W && !/\s/.test(c)) {
	          state = ATTR_VALUE
	          i--
	        } else if (state === ATTR_VALUE && /\s/.test(c)) {
	          res.push([ATTR_VALUE,reg],[ATTR_BREAK])
	          reg = ''
	          state = ATTR
	        } else if (state === ATTR_VALUE || state === ATTR_VALUE_SQ
	        || state === ATTR_VALUE_DQ) {
	          reg += c
	        }
	      }
	      if (state === TEXT && reg.length) {
	        res.push([TEXT,reg])
	        reg = ''
	      } else if (state === ATTR_VALUE && reg.length) {
	        res.push([ATTR_VALUE,reg])
	        reg = ''
	      } else if (state === ATTR_VALUE_DQ && reg.length) {
	        res.push([ATTR_VALUE,reg])
	        reg = ''
	      } else if (state === ATTR_VALUE_SQ && reg.length) {
	        res.push([ATTR_VALUE,reg])
	        reg = ''
	      } else if (state === ATTR_KEY) {
	        res.push([ATTR_KEY,reg])
	        reg = ''
	      }
	      return res
	    }
	  }
	
	  function strfn (x) {
	    if (typeof x === 'function') return x
	    else if (typeof x === 'string') return x
	    else if (x && typeof x === 'object') return x
	    else return concat('', x)
	  }
	}
	
	function quot (state) {
	  return state === ATTR_VALUE_SQ || state === ATTR_VALUE_DQ
	}
	
	var hasOwn = Object.prototype.hasOwnProperty
	function has (obj, key) { return hasOwn.call(obj, key) }
	
	var closeRE = RegExp('^(' + [
	  'area', 'base', 'basefont', 'bgsound', 'br', 'col', 'command', 'embed',
	  'frame', 'hr', 'img', 'input', 'isindex', 'keygen', 'link', 'meta', 'param',
	  'source', 'track', 'wbr',
	  // SVG TAGS
	  'animate', 'animateTransform', 'circle', 'cursor', 'desc', 'ellipse',
	  'feBlend', 'feColorMatrix', 'feComposite',
	  'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap',
	  'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR',
	  'feGaussianBlur', 'feImage', 'feMergeNode', 'feMorphology',
	  'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile',
	  'feTurbulence', 'font-face-format', 'font-face-name', 'font-face-uri',
	  'glyph', 'glyphRef', 'hkern', 'image', 'line', 'missing-glyph', 'mpath',
	  'path', 'polygon', 'polyline', 'rect', 'set', 'stop', 'tref', 'use', 'view',
	  'vkern'
	].join('|') + ')(?:[\.#][a-zA-Z0-9\u007F-\uFFFF_:-]+)*$')
	function selfClosing (tag) { return closeRE.test(tag) }


/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = attributeToProperty
	
	var transform = {
	  'class': 'className',
	  'for': 'htmlFor',
	  'http-equiv': 'httpEquiv'
	}
	
	function attributeToProperty (h) {
	  return function (tagName, attrs, children) {
	    for (var attr in attrs) {
	      if (attr in transform) {
	        attrs[transform[attr]] = attrs[attr]
	        delete attrs[attr]
	      }
	    }
	    return h(tagName, attrs, children)
	  }
	}


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/* global MutationObserver */
	var document = __webpack_require__(27)
	var window = __webpack_require__(32)
	var watch = Object.create(null)
	var KEY_ID = 'onloadid' + (new Date() % 9e6).toString(36)
	var KEY_ATTR = 'data-' + KEY_ID
	var INDEX = 0
	
	if (window && window.MutationObserver) {
	  var observer = new MutationObserver(function (mutations) {
	    if (Object.keys(watch).length < 1) return
	    for (var i = 0; i < mutations.length; i++) {
	      if (mutations[i].attributeName === KEY_ATTR) {
	        eachAttr(mutations[i], turnon, turnoff)
	        continue
	      }
	      eachMutation(mutations[i].removedNodes, turnoff)
	      eachMutation(mutations[i].addedNodes, turnon)
	    }
	  })
	  observer.observe(document.body, {
	    childList: true,
	    subtree: true,
	    attributes: true,
	    attributeOldValue: true,
	    attributeFilter: [KEY_ATTR]
	  })
	}
	
	module.exports = function onload (el, on, off, caller) {
	  on = on || function () {}
	  off = off || function () {}
	  el.setAttribute(KEY_ATTR, 'o' + INDEX)
	  watch['o' + INDEX] = [on, off, 0, caller || onload.caller]
	  INDEX += 1
	  return el
	}
	
	function turnon (index, el) {
	  if (watch[index][0] && watch[index][2] === 0) {
	    watch[index][0](el)
	    watch[index][2] = 1
	  }
	}
	
	function turnoff (index, el) {
	  if (watch[index][1] && watch[index][2] === 1) {
	    watch[index][1](el)
	    watch[index][2] = 0
	  }
	}
	
	function eachAttr (mutation, on, off) {
	  var newValue = mutation.target.getAttribute(KEY_ATTR)
	  if (sameOrigin(mutation.oldValue, newValue)) {
	    watch[newValue] = watch[mutation.oldValue]
	    return
	  }
	  if (watch[mutation.oldValue]) {
	    off(mutation.oldValue, mutation.target)
	  }
	  if (watch[newValue]) {
	    on(newValue, mutation.target)
	  }
	}
	
	function sameOrigin (oldValue, newValue) {
	  if (!oldValue || !newValue) return false
	  return watch[oldValue][3] === watch[newValue][3]
	}
	
	function eachMutation (nodes, fn) {
	  var keys = Object.keys(watch)
	  for (var i = 0; i < nodes.length; i++) {
	    if (nodes[i] && nodes[i].getAttribute && nodes[i].getAttribute(KEY_ATTR)) {
	      var onloadid = nodes[i].getAttribute(KEY_ATTR)
	      keys.forEach(function (k) {
	        if (onloadid === k) {
	          fn(k, nodes[i])
	        }
	      })
	    }
	    if (nodes[i].childNodes.length > 0) {
	      eachMutation(nodes[i].childNodes, fn)
	    }
	  }
	}


/***/ },
/* 32 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {if (typeof window !== "undefined") {
	    module.exports = window;
	} else if (typeof global !== "undefined") {
	    module.exports = global;
	} else if (typeof self !== "undefined"){
	    module.exports = self;
	} else {
	    module.exports = {};
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	// Create a range object for efficently rendering strings to elements.
	var range;
	
	var doc = typeof document !== 'undefined' && document;
	
	var testEl = doc ?
	    doc.body || doc.createElement('div') :
	    {};
	
	var NS_XHTML = 'http://www.w3.org/1999/xhtml';
	
	var ELEMENT_NODE = 1;
	var TEXT_NODE = 3;
	var COMMENT_NODE = 8;
	
	// Fixes <https://github.com/patrick-steele-idem/morphdom/issues/32>
	// (IE7+ support) <=IE7 does not support el.hasAttribute(name)
	var hasAttributeNS;
	
	if (testEl.hasAttributeNS) {
	    hasAttributeNS = function(el, namespaceURI, name) {
	        return el.hasAttributeNS(namespaceURI, name);
	    };
	} else if (testEl.hasAttribute) {
	    hasAttributeNS = function(el, namespaceURI, name) {
	        return el.hasAttribute(name);
	    };
	} else {
	    hasAttributeNS = function(el, namespaceURI, name) {
	        return !!el.getAttributeNode(name);
	    };
	}
	
	function toElement(str) {
	    if (!range && doc.createRange) {
	        range = doc.createRange();
	        range.selectNode(doc.body);
	    }
	
	    var fragment;
	    if (range && range.createContextualFragment) {
	        fragment = range.createContextualFragment(str);
	    } else {
	        fragment = doc.createElement('body');
	        fragment.innerHTML = str;
	    }
	    return fragment.childNodes[0];
	}
	
	function syncBooleanAttrProp(fromEl, toEl, name) {
	    if (fromEl[name] !== toEl[name]) {
	        fromEl[name] = toEl[name];
	        if (fromEl[name]) {
	            fromEl.setAttribute(name, '');
	        } else {
	            fromEl.removeAttribute(name, '');
	        }
	    }
	}
	
	var specialElHandlers = {
	    /**
	     * Needed for IE. Apparently IE doesn't think that "selected" is an
	     * attribute when reading over the attributes using selectEl.attributes
	     */
	    OPTION: function(fromEl, toEl) {
	        syncBooleanAttrProp(fromEl, toEl, 'selected');
	    },
	    /**
	     * The "value" attribute is special for the <input> element since it sets
	     * the initial value. Changing the "value" attribute without changing the
	     * "value" property will have no effect since it is only used to the set the
	     * initial value.  Similar for the "checked" attribute, and "disabled".
	     */
	    INPUT: function(fromEl, toEl) {
	        syncBooleanAttrProp(fromEl, toEl, 'checked');
	        syncBooleanAttrProp(fromEl, toEl, 'disabled');
	
	        if (fromEl.value !== toEl.value) {
	            fromEl.value = toEl.value;
	        }
	
	        if (!hasAttributeNS(toEl, null, 'value')) {
	            fromEl.removeAttribute('value');
	        }
	    },
	
	    TEXTAREA: function(fromEl, toEl) {
	        var newValue = toEl.value;
	        if (fromEl.value !== newValue) {
	            fromEl.value = newValue;
	        }
	
	        if (fromEl.firstChild) {
	            // Needed for IE. Apparently IE sets the placeholder as the
	            // node value and vise versa. This ignores an empty update.
	            if (newValue === '' && fromEl.firstChild.nodeValue === fromEl.placeholder) {
	                return;
	            }
	
	            fromEl.firstChild.nodeValue = newValue;
	        }
	    }
	};
	
	function noop() {}
	
	/**
	 * Returns true if two node's names are the same.
	 *
	 * NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
	 *       nodeName and different namespace URIs.
	 *
	 * @param {Element} a
	 * @param {Element} b The target element
	 * @return {boolean}
	 */
	function compareNodeNames(fromEl, toEl) {
	    var fromNodeName = fromEl.nodeName;
	    var toNodeName = toEl.nodeName;
	
	    if (fromNodeName === toNodeName) {
	        return true;
	    }
	
	    if (toEl.actualize &&
	        fromNodeName.charCodeAt(0) < 91 && /* from tag name is upper case */
	        toNodeName.charCodeAt(0) > 90 /* target tag name is lower case */) {
	        // If the target element is a virtual DOM node then we may need to normalize the tag name
	        // before comparing. Normal HTML elements that are in the "http://www.w3.org/1999/xhtml"
	        // are converted to upper case
	        return fromNodeName === toNodeName.toUpperCase();
	    } else {
	        return false;
	    }
	}
	
	/**
	 * Create an element, optionally with a known namespace URI.
	 *
	 * @param {string} name the element name, e.g. 'div' or 'svg'
	 * @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
	 * its `xmlns` attribute or its inferred namespace.
	 *
	 * @return {Element}
	 */
	function createElementNS(name, namespaceURI) {
	    return !namespaceURI || namespaceURI === NS_XHTML ?
	        doc.createElement(name) :
	        doc.createElementNS(namespaceURI, name);
	}
	
	/**
	 * Loop over all of the attributes on the target node and make sure the original
	 * DOM node has the same attributes. If an attribute found on the original node
	 * is not on the new node then remove it from the original node.
	 *
	 * @param  {Element} fromNode
	 * @param  {Element} toNode
	 */
	function morphAttrs(fromNode, toNode) {
	    if (toNode.assignAttributes) {
	        toNode.assignAttributes(fromNode);
	    } else {
	        var attrs = toNode.attributes;
	        var i;
	        var attr;
	        var attrName;
	        var attrNamespaceURI;
	        var attrValue;
	        var fromValue;
	
	        for (i = attrs.length - 1; i >= 0; --i) {
	            attr = attrs[i];
	            attrName = attr.name;
	            attrNamespaceURI = attr.namespaceURI;
	            attrValue = attr.value;
	
	            if (attrNamespaceURI) {
	                attrName = attr.localName || attrName;
	                fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);
	
	                if (fromValue !== attrValue) {
	                    fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
	                }
	            } else {
	                fromValue = fromNode.getAttribute(attrName);
	
	                if (fromValue !== attrValue) {
	                    fromNode.setAttribute(attrName, attrValue);
	                }
	            }
	        }
	
	        // Remove any extra attributes found on the original DOM element that
	        // weren't found on the target element.
	        attrs = fromNode.attributes;
	
	        for (i = attrs.length - 1; i >= 0; --i) {
	            attr = attrs[i];
	            if (attr.specified !== false) {
	                attrName = attr.name;
	                attrNamespaceURI = attr.namespaceURI;
	
	                if (attrNamespaceURI) {
	                    attrName = attr.localName || attrName;
	
	                    if (!hasAttributeNS(toNode, attrNamespaceURI, attrName)) {
	                        fromNode.removeAttributeNS(attrNamespaceURI, attrName);
	                    }
	                } else {
	                    if (!hasAttributeNS(toNode, null, attrName)) {
	                        fromNode.removeAttribute(attrName);
	                    }
	                }
	            }
	        }
	    }
	}
	
	/**
	 * Copies the children of one DOM element to another DOM element
	 */
	function moveChildren(fromEl, toEl) {
	    var curChild = fromEl.firstChild;
	    while (curChild) {
	        var nextChild = curChild.nextSibling;
	        toEl.appendChild(curChild);
	        curChild = nextChild;
	    }
	    return toEl;
	}
	
	function defaultGetNodeKey(node) {
	    return node.id;
	}
	
	function morphdom(fromNode, toNode, options) {
	    if (!options) {
	        options = {};
	    }
	
	    if (typeof toNode === 'string') {
	        if (fromNode.nodeName === '#document' || fromNode.nodeName === 'HTML') {
	            var toNodeHtml = toNode;
	            toNode = doc.createElement('html');
	            toNode.innerHTML = toNodeHtml;
	        } else {
	            toNode = toElement(toNode);
	        }
	    }
	
	    var getNodeKey = options.getNodeKey || defaultGetNodeKey;
	    var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
	    var onNodeAdded = options.onNodeAdded || noop;
	    var onBeforeElUpdated = options.onBeforeElUpdated || noop;
	    var onElUpdated = options.onElUpdated || noop;
	    var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
	    var onNodeDiscarded = options.onNodeDiscarded || noop;
	    var onBeforeElChildrenUpdated = options.onBeforeElChildrenUpdated || noop;
	    var childrenOnly = options.childrenOnly === true;
	
	    // This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
	    var fromNodesLookup = {};
	    var keyedRemovalList;
	
	    function addKeyedRemoval(key) {
	        if (keyedRemovalList) {
	            keyedRemovalList.push(key);
	        } else {
	            keyedRemovalList = [key];
	        }
	    }
	
	    function walkDiscardedChildNodes(node, skipKeyedNodes) {
	        if (node.nodeType === ELEMENT_NODE) {
	            var curChild = node.firstChild;
	            while (curChild) {
	
	                var key = undefined;
	
	                if (skipKeyedNodes && (key = getNodeKey(curChild))) {
	                    // If we are skipping keyed nodes then we add the key
	                    // to a list so that it can be handled at the very end.
	                    addKeyedRemoval(key);
	                } else {
	                    // Only report the node as discarded if it is not keyed. We do this because
	                    // at the end we loop through all keyed elements that were unmatched
	                    // and then discard them in one final pass.
	                    onNodeDiscarded(curChild);
	                    if (curChild.firstChild) {
	                        walkDiscardedChildNodes(curChild, skipKeyedNodes);
	                    }
	                }
	
	                curChild = curChild.nextSibling;
	            }
	        }
	    }
	
	    /**
	     * Removes a DOM node out of the original DOM
	     *
	     * @param  {Node} node The node to remove
	     * @param  {Node} parentNode The nodes parent
	     * @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
	     * @return {undefined}
	     */
	    function removeNode(node, parentNode, skipKeyedNodes) {
	        if (onBeforeNodeDiscarded(node) === false) {
	            return;
	        }
	
	        if (parentNode) {
	            parentNode.removeChild(node);
	        }
	
	        onNodeDiscarded(node);
	        walkDiscardedChildNodes(node, skipKeyedNodes);
	    }
	
	    // // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
	    // function indexTree(root) {
	    //     var treeWalker = document.createTreeWalker(
	    //         root,
	    //         NodeFilter.SHOW_ELEMENT);
	    //
	    //     var el;
	    //     while((el = treeWalker.nextNode())) {
	    //         var key = getNodeKey(el);
	    //         if (key) {
	    //             fromNodesLookup[key] = el;
	    //         }
	    //     }
	    // }
	
	    // // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
	    //
	    // function indexTree(node) {
	    //     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
	    //     var el;
	    //     while((el = nodeIterator.nextNode())) {
	    //         var key = getNodeKey(el);
	    //         if (key) {
	    //             fromNodesLookup[key] = el;
	    //         }
	    //     }
	    // }
	
	    function indexTree(node) {
	        if (node.nodeType === ELEMENT_NODE) {
	            var curChild = node.firstChild;
	            while (curChild) {
	                var key = getNodeKey(curChild);
	                if (key) {
	                    fromNodesLookup[key] = curChild;
	                }
	
	                // Walk recursively
	                indexTree(curChild);
	
	                curChild = curChild.nextSibling;
	            }
	        }
	    }
	
	    indexTree(fromNode);
	
	    function handleNodeAdded(el) {
	        onNodeAdded(el);
	
	        var curChild = el.firstChild;
	        while (curChild) {
	            var nextSibling = curChild.nextSibling;
	
	            var key = getNodeKey(curChild);
	            if (key) {
	                var unmatchedFromEl = fromNodesLookup[key];
	                if (unmatchedFromEl && compareNodeNames(curChild, unmatchedFromEl)) {
	                    curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
	                    morphEl(unmatchedFromEl, curChild);
	                }
	            }
	
	            handleNodeAdded(curChild);
	            curChild = nextSibling;
	        }
	    }
	
	    function morphEl(fromEl, toEl, childrenOnly) {
	        var toElKey = getNodeKey(toEl);
	        var curFromNodeKey;
	
	        if (toElKey) {
	            // If an element with an ID is being morphed then it is will be in the final
	            // DOM so clear it out of the saved elements collection
	            delete fromNodesLookup[toElKey];
	        }
	
	        if (toNode.isSameNode && toNode.isSameNode(fromNode)) {
	            return;
	        }
	
	        if (!childrenOnly) {
	            if (onBeforeElUpdated(fromEl, toEl) === false) {
	                return;
	            }
	
	            morphAttrs(fromEl, toEl);
	            onElUpdated(fromEl);
	
	            if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
	                return;
	            }
	        }
	
	        if (fromEl.nodeName !== 'TEXTAREA') {
	            var curToNodeChild = toEl.firstChild;
	            var curFromNodeChild = fromEl.firstChild;
	            var curToNodeKey;
	
	            var fromNextSibling;
	            var toNextSibling;
	            var matchingFromEl;
	
	            outer: while (curToNodeChild) {
	                toNextSibling = curToNodeChild.nextSibling;
	                curToNodeKey = getNodeKey(curToNodeChild);
	
	                while (curFromNodeChild) {
	                    fromNextSibling = curFromNodeChild.nextSibling;
	
	                    if (curToNodeChild.isSameNode && curToNodeChild.isSameNode(curFromNodeChild)) {
	                        curToNodeChild = toNextSibling;
	                        curFromNodeChild = fromNextSibling;
	                        continue outer;
	                    }
	
	                    curFromNodeKey = getNodeKey(curFromNodeChild);
	
	                    var curFromNodeType = curFromNodeChild.nodeType;
	
	                    var isCompatible = undefined;
	
	                    if (curFromNodeType === curToNodeChild.nodeType) {
	                        if (curFromNodeType === ELEMENT_NODE) {
	                            // Both nodes being compared are Element nodes
	
	                            if (curToNodeKey) {
	                                // The target node has a key so we want to match it up with the correct element
	                                // in the original DOM tree
	                                if (curToNodeKey !== curFromNodeKey) {
	                                    // The current element in the original DOM tree does not have a matching key so
	                                    // let's check our lookup to see if there is a matching element in the original
	                                    // DOM tree
	                                    if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
	                                        if (curFromNodeChild.nextSibling === matchingFromEl) {
	                                            // Special case for single element removals. To avoid removing the original
	                                            // DOM node out of the tree (since that can break CSS transitions, etc.),
	                                            // we will instead discard the current node and wait until the next
	                                            // iteration to properly match up the keyed target element with its matching
	                                            // element in the original tree
	                                            isCompatible = false;
	                                        } else {
	                                            // We found a matching keyed element somewhere in the original DOM tree.
	                                            // Let's moving the original DOM node into the current position and morph
	                                            // it.
	
	                                            // NOTE: We use insertBefore instead of replaceChild because we want to go through
	                                            // the `removeNode()` function for the node that is being discarded so that
	                                            // all lifecycle hooks are correctly invoked
	                                            fromEl.insertBefore(matchingFromEl, curFromNodeChild);
	
	                                            fromNextSibling = curFromNodeChild.nextSibling;
	
	                                            if (curFromNodeKey) {
	                                                // Since the node is keyed it might be matched up later so we defer
	                                                // the actual removal to later
	                                                addKeyedRemoval(curFromNodeKey);
	                                            } else {
	                                                // NOTE: we skip nested keyed nodes from being removed since there is
	                                                //       still a chance they will be matched up later
	                                                removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
	                                            }
	
	                                            curFromNodeChild = matchingFromEl;
	                                        }
	                                    } else {
	                                        // The nodes are not compatible since the "to" node has a key and there
	                                        // is no matching keyed node in the source tree
	                                        isCompatible = false;
	                                    }
	                                }
	                            } else if (curFromNodeKey) {
	                                // The original has a key
	                                isCompatible = false;
	                            }
	
	                            isCompatible = isCompatible !== false && compareNodeNames(curFromNodeChild, curToNodeChild);
	                            if (isCompatible) {
	                                // We found compatible DOM elements so transform
	                                // the current "from" node to match the current
	                                // target DOM node.
	                                morphEl(curFromNodeChild, curToNodeChild);
	                            }
	
	                        } else if (curFromNodeType === TEXT_NODE || curFromNodeType == COMMENT_NODE) {
	                            // Both nodes being compared are Text or Comment nodes
	                            isCompatible = true;
	                            // Simply update nodeValue on the original node to
	                            // change the text value
	                            curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
	                        }
	                    }
	
	                    if (isCompatible) {
	                        // Advance both the "to" child and the "from" child since we found a match
	                        curToNodeChild = toNextSibling;
	                        curFromNodeChild = fromNextSibling;
	                        continue outer;
	                    }
	
	                    // No compatible match so remove the old node from the DOM and continue trying to find a
	                    // match in the original DOM. However, we only do this if the from node is not keyed
	                    // since it is possible that a keyed node might match up with a node somewhere else in the
	                    // target tree and we don't want to discard it just yet since it still might find a
	                    // home in the final DOM tree. After everything is done we will remove any keyed nodes
	                    // that didn't find a home
	                    if (curFromNodeKey) {
	                        // Since the node is keyed it might be matched up later so we defer
	                        // the actual removal to later
	                        addKeyedRemoval(curFromNodeKey);
	                    } else {
	                        // NOTE: we skip nested keyed nodes from being removed since there is
	                        //       still a chance they will be matched up later
	                        removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
	                    }
	
	                    curFromNodeChild = fromNextSibling;
	                }
	
	                // If we got this far then we did not find a candidate match for
	                // our "to node" and we exhausted all of the children "from"
	                // nodes. Therefore, we will just append the current "to" node
	                // to the end
	                if (curToNodeKey && (matchingFromEl = fromNodesLookup[curToNodeKey]) && compareNodeNames(matchingFromEl, curToNodeChild)) {
	                    fromEl.appendChild(matchingFromEl);
	                    morphEl(matchingFromEl, curToNodeChild);
	                } else {
	                    var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
	                    if (onBeforeNodeAddedResult !== false) {
	                        if (onBeforeNodeAddedResult) {
	                            curToNodeChild = onBeforeNodeAddedResult;
	                        }
	
	                        if (curToNodeChild.actualize) {
	                            curToNodeChild = curToNodeChild.actualize(fromEl.ownerDocument || doc);
	                        }
	                        fromEl.appendChild(curToNodeChild);
	                        handleNodeAdded(curToNodeChild);
	                    }
	                }
	
	                curToNodeChild = toNextSibling;
	                curFromNodeChild = fromNextSibling;
	            }
	
	            // We have processed all of the "to nodes". If curFromNodeChild is
	            // non-null then we still have some from nodes left over that need
	            // to be removed
	            while (curFromNodeChild) {
	                fromNextSibling = curFromNodeChild.nextSibling;
	                if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
	                    // Since the node is keyed it might be matched up later so we defer
	                    // the actual removal to later
	                    addKeyedRemoval(curFromNodeKey);
	                } else {
	                    // NOTE: we skip nested keyed nodes from being removed since there is
	                    //       still a chance they will be matched up later
	                    removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
	                }
	                curFromNodeChild = fromNextSibling;
	            }
	        }
	
	        var specialElHandler = specialElHandlers[fromEl.nodeName];
	        if (specialElHandler) {
	            specialElHandler(fromEl, toEl);
	        }
	    } // END: morphEl(...)
	
	    var morphedNode = fromNode;
	    var morphedNodeType = morphedNode.nodeType;
	    var toNodeType = toNode.nodeType;
	
	    if (!childrenOnly) {
	        // Handle the case where we are given two DOM nodes that are not
	        // compatible (e.g. <div> --> <span> or <div> --> TEXT)
	        if (morphedNodeType === ELEMENT_NODE) {
	            if (toNodeType === ELEMENT_NODE) {
	                if (!compareNodeNames(fromNode, toNode)) {
	                    onNodeDiscarded(fromNode);
	                    morphedNode = moveChildren(fromNode, createElementNS(toNode.nodeName, toNode.namespaceURI));
	                }
	            } else {
	                // Going from an element node to a text node
	                morphedNode = toNode;
	            }
	        } else if (morphedNodeType === TEXT_NODE || morphedNodeType === COMMENT_NODE) { // Text or comment node
	            if (toNodeType === morphedNodeType) {
	                morphedNode.nodeValue = toNode.nodeValue;
	                return morphedNode;
	            } else {
	                // Text node to something else
	                morphedNode = toNode;
	            }
	        }
	    }
	
	    if (morphedNode === toNode) {
	        // The "to node" was not compatible with the "from node" so we had to
	        // toss out the "from node" and use the "to node"
	        onNodeDiscarded(fromNode);
	    } else {
	        morphEl(morphedNode, toNode, childrenOnly);
	
	        // We now need to loop over any keyed nodes that might need to be
	        // removed. We only do the removal if we know that the keyed node
	        // never found a match. When a keyed node is matched up we remove
	        // it out of fromNodesLookup and we use fromNodesLookup to determine
	        // if a keyed node has been matched up or not
	        if (keyedRemovalList) {
	            for (var i=0, len=keyedRemovalList.length; i<len; i++) {
	                var elToRemove = fromNodesLookup[keyedRemovalList[i]];
	                if (elToRemove) {
	                    removeNode(elToRemove, elToRemove.parentNode, false);
	                }
	            }
	        }
	    }
	
	    if (!childrenOnly && morphedNode !== fromNode && fromNode.parentNode) {
	        if (morphedNode.actualize) {
	            morphedNode = morphedNode.actualize(fromNode.ownerDocument || doc);
	        }
	        // If we had to swap out the from node with a new node because the old
	        // node was not compatible with the target node then we need to
	        // replace the old DOM node in the original DOM tree. This is only
	        // possible if the original DOM node was part of a DOM tree which
	        // we know is the case if it has a parent node.
	        fromNode.parentNode.replaceChild(morphedNode, fromNode);
	    }
	
	    return morphedNode;
	}
	
	module.exports = morphdom;


/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = [
	  // attribute events (can be set with attributes)
	  'onclick',
	  'ondblclick',
	  'onmousedown',
	  'onmouseup',
	  'onmouseover',
	  'onmousemove',
	  'onmouseout',
	  'ondragstart',
	  'ondrag',
	  'ondragenter',
	  'ondragleave',
	  'ondragover',
	  'ondrop',
	  'ondragend',
	  'onkeydown',
	  'onkeypress',
	  'onkeyup',
	  'onunload',
	  'onabort',
	  'onerror',
	  'onresize',
	  'onscroll',
	  'onselect',
	  'onchange',
	  'onsubmit',
	  'onreset',
	  'onfocus',
	  'onblur',
	  'oninput',
	  // other common events
	  'oncontextmenu',
	  'onfocusin',
	  'onfocusout'
	]


/***/ },
/* 35 */
/***/ function(module, exports) {

	var containers = []; // will store container HTMLElement references
	var styleElements = []; // will store {prepend: HTMLElement, append: HTMLElement}
	
	var usage = 'insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).';
	
	function insertCss(css, options) {
	    options = options || {};
	
	    if (css === undefined) {
	        throw new Error(usage);
	    }
	
	    var position = options.prepend === true ? 'prepend' : 'append';
	    var container = options.container !== undefined ? options.container : document.querySelector('head');
	    var containerId = containers.indexOf(container);
	
	    // first time we see this container, create the necessary entries
	    if (containerId === -1) {
	        containerId = containers.push(container) - 1;
	        styleElements[containerId] = {};
	    }
	
	    // try to get the correponding container + position styleElement, create it otherwise
	    var styleElement;
	
	    if (styleElements[containerId] !== undefined && styleElements[containerId][position] !== undefined) {
	        styleElement = styleElements[containerId][position];
	    } else {
	        styleElement = styleElements[containerId][position] = createStyleElement();
	
	        if (position === 'prepend') {
	            container.insertBefore(styleElement, container.childNodes[0]);
	        } else {
	            container.appendChild(styleElement);
	        }
	    }
	
	    // strip potential UTF-8 BOM if css was read from a file
	    if (css.charCodeAt(0) === 0xFEFF) { css = css.substr(1, css.length); }
	
	    // actually add the stylesheet
	    if (styleElement.styleSheet) {
	        styleElement.styleSheet.cssText += css
	    } else {
	        styleElement.textContent += css;
	    }
	
	    return styleElement;
	};
	
	function createStyleElement() {
	    var styleElement = document.createElement('style');
	    styleElement.setAttribute('type', 'text/css');
	    return styleElement;
	}
	
	module.exports = insertCss;
	module.exports.insertCss = insertCss;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _windowJquery = __webpack_require__(37);
	
	var _windowJquery2 = _interopRequireDefault(_windowJquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginState = function () {
		function LoginState() {
			_classCallCheck(this, LoginState);
	
			this.ON_LOGIN = typeof Symbol === 'undefined' ? 'ON_LOGIN' : Symbol('ON_LOGIN');
			this.ON_LOGOUT = typeof Symbol === 'undefined' ? 'ON_LOGOUT' : Symbol('ON_LOGOUT');
	
			this.listeners = new Map();
			this.listeners.set(this.ON_LOGIN, []);
			this.listeners.set(this.ON_LOGOUT, []);
	
			this.watchEvent();
		}
	
		_createClass(LoginState, [{
			key: 'getListener',
			value: function getListener(key) {
				return this.listeners.get(key);
			}
		}, {
			key: 'onLogin',
			value: function onLogin(callback) {
				this.getListener(this.ON_LOGIN).push(callback);
			}
		}, {
			key: 'onLogout',
			value: function onLogout(callback) {
				this.getListener(this.ON_LOGOUT).push(callback);
			}
		}, {
			key: 'watchEvent',
			value: function watchEvent() {
				var _this = this;
	
				var body = (0, _windowJquery2.default)('body');
	
				body.on('isLogin', function (info) {
					_this.getListener(_this.ON_LOGIN).forEach(function (callback) {
						callback(info);
					});
				});
	
				body.on('isLogout', function (info) {
					_this.getListener(_this.ON_LOGOUT).forEach(function (callback) {
						callback(info);
					});
				});
			}
		}]);
	
		return LoginState;
	}();
	
	exports.default = LoginState;

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = window.jQuery;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getJson = getJson;
	exports.postJson = postJson;
	exports.jsonToStringParams = jsonToStringParams;
	function getJson(url) {
		var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	
		return new Promise(function (resolve, reject) {
			var params = jsonToStringParams(data);
	
			url += (url.indexOf('?') == -1 ? '?' : '&') + params;
	
			fetch(url, {
				method: 'GET',
				mode: 'cors',
				redirect: 'follow',
				credentials: 'include',
				headers: new Headers({ 'Content-Type': 'application/json' })
			}).then(function (response) {
				var contentType = response.headers.get("content-type");
				if (contentType && contentType.indexOf("application/json") !== -1) {
					return response.json().then(function (json) {
						resolve(json);
					});
				} else {
					try {
						response.json().then(function (res) {
							return resolve(res);
						});
					} catch (error) {
						resolve(response);
					}
				}
			}).catch(function (err) {
				return reject(err);
			});
		});
	}
	
	function postJson(url) {
		var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	
		return new Promise(function (resolve, reject) {
			fetch(url, {
				body: JSON.stringify(body),
				method: 'POST',
				mode: 'cors',
				redirect: 'follow',
				credentials: 'include',
				headers: new Headers({ 'Content-Type': 'application/json' })
			}).then(function (response) {
				var contentType = response.headers.get("content-type");
				if (contentType && contentType.indexOf("application/json") !== -1) {
					return response.json().then(function (json) {
						resolve(json);
					});
				} else {
					//console.log("Oops, we haven't got JSON!");
					resolve(res);
				}
			}).catch(function (err) {
				return reject(err);
			});
		});
	}
	
	function jsonToStringParams() {
		var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		var url = Object.keys(data).map(function (k) {
			return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
		}).join('&');
	
		return url;
	}
	
	var request = {
		getJson: getJson,
		postJson: postJson,
		jsonToStringParams: jsonToStringParams
	};
	
	exports.default = request;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(9)))

/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = create;
	exports.read = read;
	exports.remove = remove;
	
	/**
	 * create cookies.
	 * @param  {string} name  name of cookie
	 * @param  {object} value value store in cookie
	 * @param  {number} sec   time cookie expire in second.
	 * @return {null}       
	 */
	function create(name, value, sec) {
	  if (sec) {
	    var date = new Date();
	    date.setTime(date.getTime() + sec * 1000);
	    var expires = "; expires=" + date.toGMTString();
	  } else var expires = "";
	  document.cookie = name + "=" + value + expires + "; path=/";
	}
	
	/**
	 * read cookie from cookie's name
	 * @param  {string} name name of target cookie to read.
	 * @return {string}      cookie value in string or null if cookie not found.
	 */
	function read(name) {
	  var nameEQ = name + "=";
	  var ca = document.cookie.split(';');
	  for (var i = 0; i < ca.length; i++) {
	    var c = ca[i];
	    while (c.charAt(0) == ' ') {
	      c = c.substring(1, c.length);
	    }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	  }
	  return null;
	}
	
	/**
	 * remore target cookie
	 * @param  {string} name cookie name to remove
	 * @return {null}      
	 */
	function remove(name) {
	  this.create(name, "", -1);
	}
	
	var cookie = {
	  create: create,
	  read: read,
	  remove: remove
	};
	
	exports.default = cookie;

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function track(category, action, label) {
		if (typeof window.trackEvent !== 'undefined') {
			window.trackEvent(category, action, label);
		}
	}
	
	exports.default = track;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _request = __webpack_require__(38);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SubscribeCategory = function () {
		function SubscribeCategory() {
			_classCallCheck(this, SubscribeCategory);
		}
	
		_createClass(SubscribeCategory, null, [{
			key: 'isUserSubscribeCategory',
			value: function isUserSubscribeCategory(categoryMain, categorySub) {
				return new Promise(function (resolve, reject) {
					(0, _request.getJson)('/api/article/isSubscribe/' + categoryMain + '/' + categorySub).then(function (response) {
						//console.log('is subscribe', response);
						resolve(response.isSubscribe);
					}).catch(function (error) {
						reject(error);
					});
				});
			}
		}, {
			key: 'subscribe',
			value: function subscribe(categoryMain) {
				return new Promise(function (resolve, reject) {
					//console.log('subscribe start')
					(0, _request.getJson)('/api/article/subscribe/' + categoryMain + '/0').then(function (response) {
						//console.log('subscribe finish', response)
						resolve(response);
					}).catch(function (error) {
						reject(error);
					});
				});
			}
		}, {
			key: 'subscribeManager',
			value: function subscribeManager() {}
		}]);
	
		return SubscribeCategory;
	}();
	
	exports.default = SubscribeCategory;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** /article/js/dist/notification-subscribe.js
 **/